:root {
  /* SPACING */
  --aiba-spacing-1: 0.0625rem;
  --aiba-spacing-2: 0.125rem;
  --aiba-spacing-4: 0.25rem;
  --aiba-spacing-6: 0.375rem;
  --aiba-spacing-8: 0.5rem;
  --aiba-spacing-10: 0.625rem;
  --aiba-spacing-12: 0.75rem;
  --aiba-spacing-16: 1rem;
  --aiba-spacing-24: 1.5rem;
  --aiba-spacing-32: 2rem;
  --aiba-spacing-40: 2.5rem;
  --aiba-spacing-48: 3rem;
  --aiba-spacing-64: 4rem;
  --aiba-spacing-80: 5rem;
  --aiba-spacing-100: 6.25rem;
  /* FONT */
  --aiba-font-family-robo: roboto, sans-serif;
  --aiba-font-family-mont: Montserrat, sans-serif;
  --aiba-font-size-10: 0.625rem;
  --aiba-font-size-12: 0.75rem;
  --aiba-font-size-14: 0.875rem;
  --aiba-font-size-16: 1rem;
  --aiba-font-size-20: 1.25rem;
  --aiba-font-size-24: 1.5rem;
  --aiba-font-size-32: 2rem;
  --aiba-font-size-40: 2.5rem;
  --aiba-font-size-56: 3.5rem;
  --aiba-font-weight-thin: 200;
  --aiba-font-weight-regular: 400;
  --aiba-font-weight-medium: 500;
  --aiba-font-weight-bold: 700;
  --aiba-font-weight-extrabold: 800;
  --aiba-font-line-height-114: 114%;
  --aiba-font-line-height-120: 120%;
  --aiba-font-line-height-125: 125%;
  --aiba-font-line-height-133: 133%;
  --aiba-font-line-height-150: 150%;
  --aiba-font-line-height-160: 160%;
  /* FONT-VARIANT */
  --aiba-font-variant-body-family: roboto, sans-serif;
  --aiba-font-variant-body-size: 1rem;
  --aiba-font-variant-body-weight: 400;
  --aiba-font-variant-body-line-height: 150%;
  --aiba-font-variant-body-letter-spacing: normal;
  --aiba-font-variant-body-short-family: roboto, sans-serif;
  --aiba-font-variant-body-short-size: 1rem;
  --aiba-font-variant-body-short-weight: 400;
  --aiba-font-variant-body-short-line-height: 125%;
  --aiba-font-variant-body-short-letter-spacing: normal;
  --aiba-font-variant-body-large-family: roboto, sans-serif;
  --aiba-font-variant-body-large-size: 1.25rem;
  --aiba-font-variant-body-large-weight: 400;
  --aiba-font-variant-body-large-line-height: 160%;
  --aiba-font-variant-body-large-letter-spacing: normal;
  --aiba-font-variant-smaller-family: roboto, sans-serif;
  --aiba-font-variant-smaller-size: 0.75rem;
  --aiba-font-variant-smaller-weight: 400;
  --aiba-font-variant-smaller-line-height: 125%;
  --aiba-font-variant-smaller-letter-spacing: normal;
  --aiba-font-variant-label-family: roboto, sans-serif;
  --aiba-font-variant-label-size: 0.75rem;
  --aiba-font-variant-label-weight: 400;
  --aiba-font-variant-label-line-height: 120%;
  --aiba-font-variant-label-letter-spacing: normal;
  --aiba-font-variant-caption-family: roboto, sans-serif;
  --aiba-font-variant-caption-size: 0.75rem;
  --aiba-font-variant-caption-weight: 400;
  --aiba-font-variant-caption-line-height: 133%;
  --aiba-font-variant-caption-letter-spacing: normal;
  --aiba-font-variant-heading-8-family: roboto, sans-serif;
  --aiba-font-variant-heading-8-size: 1.5rem;
  --aiba-font-variant-heading-8-weight: 400;
  --aiba-font-variant-heading-8-line-height: 133%;
  --aiba-font-variant-heading-8-letter-spacing: normal;
  --aiba-font-variant-heading-7-family: Montserrat, sans-serif;
  --aiba-font-variant-heading-7-size: 1.5rem;
  --aiba-font-variant-heading-7-weight: 700;
  --aiba-font-variant-heading-7-line-height: 133%;
  --aiba-font-variant-heading-7-letter-spacing: normal;
  --aiba-font-variant-heading-6-family: roboto, sans-serif;
  --aiba-font-variant-heading-6-size: 1rem;
  --aiba-font-variant-heading-6-weight: 700;
  --aiba-font-variant-heading-6-line-height: 150%;
  --aiba-font-variant-heading-6-letter-spacing: normal;
  --aiba-font-variant-heading-5-family: roboto, sans-serif;
  --aiba-font-variant-heading-5-size: 1.25rem;
  --aiba-font-variant-heading-5-weight: 800;
  --aiba-font-variant-heading-5-line-height: 125%;
  --aiba-font-variant-heading-5-letter-spacing: normal;
  --aiba-font-variant-heading-4-family: roboto, sans-serif;
  --aiba-font-variant-heading-4-size: 1.5rem;
  --aiba-font-variant-heading-4-weight: 800;
  --aiba-font-variant-heading-4-line-height: 133%;
  --aiba-font-variant-heading-4-letter-spacing: normal;
  --aiba-font-variant-heading-3-family: roboto, sans-serif;
  --aiba-font-variant-heading-3-size: 2rem;
  --aiba-font-variant-heading-3-weight: 400;
  --aiba-font-variant-heading-3-line-height: 125%;
  --aiba-font-variant-heading-3-letter-spacing: normal;
  --aiba-font-variant-heading-2-family: Montserrat, sans-serif;
  --aiba-font-variant-heading-2-size: 2rem;
  --aiba-font-variant-heading-2-weight: 700;
  --aiba-font-variant-heading-2-line-height: 125%;
  --aiba-font-variant-heading-2-letter-spacing: normal;
  --aiba-font-variant-heading-1-family: roboto, sans-serif;
  --aiba-font-variant-heading-1-size: 3.5rem;
  --aiba-font-variant-heading-1-weight: 800;
  --aiba-font-variant-heading-1-line-height: 114%;
  --aiba-font-variant-heading-1-letter-spacing: normal;
  /* COLOR */
  --aiba-color-primary: hsl(329.20000000000005, 100%, 44.3%);
  --aiba-color-black: hsl(0, 0%, 0%);
  --aiba-color-white: hsl(0, 0%, 100%);
  --aiba-color-grey-0: hsl(0, 0%, 94.9%);
  --aiba-color-grey-10: hsl(0, 0%, 89.8%);
  --aiba-color-grey-20: hsl(0, 0%, 80%);
  --aiba-color-grey-30: hsl(0, 0%, 69.8%);
  --aiba-color-grey-40: hsl(0, 0%, 60%);
  --aiba-color-grey-50: hsl(0, 0%, 49.8%);
  --aiba-color-grey-60: hsl(0, 0%, 40%);
  --aiba-color-grey-70: hsl(0, 0%, 29.8%);
  --aiba-color-grey-80: hsl(0, 0%, 20%);
  --aiba-color-grey-90: hsl(0, 0%, 9.8%);
  --aiba-color-grey-100: hsl(0, 0%, 0%);
  --aiba-color-grey-101: hsl(216, 12.8%, 92.4%);
  --aiba-color-grey-102: hsl(197.60000000000002, 14.8%, 77.5%);
  --aiba-color-grey-103: hsl(0, 0%, 26.7%);
  --aiba-color-grey-104: hsl(229.10000000000002, 37.9%, 11.4%);
  --aiba-color-grey-105: hsl(180, 1.8%, 89.2%);
  --aiba-color-orange-0: hsl(54.39999999999998, 100%, 93.7%);
  --aiba-color-orange-10: hsl(48.39999999999998, 100%, 88.8%);
  --aiba-color-orange-20: hsl(43.69999999999999, 100%, 84.1%);
  --aiba-color-orange-30: hsl(38.69999999999999, 100%, 79.6%);
  --aiba-color-orange-40: hsl(33.5, 100%, 75.1%);
  --aiba-color-orange-50: hsl(29, 100%, 70.8%);
  --aiba-color-orange-60: hsl(24.80000000000001, 96.5%, 66.1%);
  --aiba-color-orange-70: hsl(17.30000000000001, 71.4%, 56.1%);
  --aiba-color-orange-80: hsl(17.30000000000001, 72.3%, 39.6%);
  --aiba-color-orange-90: hsl(17.30000000000001, 88.8%, 31.4%);
  --aiba-color-orange-100: hsl(11.399999999999977, 86.6%, 26.3%);
  --aiba-color-orange-101: hsl(43.30000000000001, 90.4%, 45.1%);
  --aiba-color-orange-102: hsl(43.39999999999998, 62.7%, 85.3%);
  --aiba-color-orange-103: hsl(43.10000000000002, 100%, 39%);
  --aiba-color-red-0: hsl(353.79999999999995, 100%, 88.6%);
  --aiba-color-red-10: hsl(351.5, 100%, 83.3%);
  --aiba-color-red-20: hsl(350.4, 98.1%, 78.8%);
  --aiba-color-red-30: hsl(350.6, 91%, 73.9%);
  --aiba-color-red-40: hsl(350.4, 85.1%, 68.4%);
  --aiba-color-red-50: hsl(350.29999999999995, 82.8%, 63.5%);
  --aiba-color-red-60: hsl(351.20000000000005, 82.6%, 59.4%);
  --aiba-color-red-70: hsl(349.70000000000005, 69%, 50.6%);
  --aiba-color-red-80: hsl(348.9, 74.9%, 43.7%);
  --aiba-color-red-90: hsl(347.1, 84%, 36.9%);
  --aiba-color-red-100: hsl(345.9, 100%, 30%);
  --aiba-color-red-101: hsl(10.199999999999989, 38.5%, 52.2%);
  --aiba-color-red-102: hsl(335.9, 66.2%, 53.5%);
  --aiba-color-blue-0: hsl(190.20000000000005, 100%, 92%);
  --aiba-color-blue-10: hsl(196.20000000000005, 100%, 85.5%);
  --aiba-color-blue-20: hsl(200.89999999999998, 100%, 79.2%);
  --aiba-color-blue-30: hsl(206, 100%, 73.3%);
  --aiba-color-blue-40: hsl(210.70000000000005, 100%, 67.5%);
  --aiba-color-blue-50: hsl(215.60000000000002, 100%, 62%);
  --aiba-color-blue-60: hsl(220, 100%, 56.5%);
  --aiba-color-blue-70: hsl(227.39999999999998, 89%, 46.3%);
  --aiba-color-blue-80: hsl(236.5, 100%, 37.5%);
  --aiba-color-blue-90: hsl(241.10000000000002, 100%, 31.2%);
  --aiba-color-blue-100: hsl(249.39999999999998, 100%, 25.1%);
  --aiba-color-blue-101: hsl(193, 100%, 27.1%);
  --aiba-color-blue-102: hsl(207.89999999999998, 80.4%, 32%);
  --aiba-color-blue-103: hsl(208.39999999999998, 100%, 92.5%);
  --aiba-color-blue-104: hsl(220.29999999999995, 58.4%, 24.5%);
  --aiba-color-teal-0: hsl(176.10000000000002, 63.3%, 90.4%);
  --aiba-color-teal-10: hsl(178.89999999999998, 60%, 82.4%);
  --aiba-color-teal-20: hsl(180, 58.5%, 74.5%);
  --aiba-color-teal-30: hsl(181.20000000000005, 57.6%, 66.7%);
  --aiba-color-teal-40: hsl(182.10000000000002, 55.2%, 58.8%);
  --aiba-color-teal-50: hsl(183.60000000000002, 53.8%, 50.8%);
  --aiba-color-teal-60: hsl(184.79999999999995, 68.9%, 42.9%);
  --aiba-color-teal-70: hsl(182.89999999999998, 80.1%, 35.5%);
  --aiba-color-teal-80: hsl(180.5, 91.5%, 27.8%);
  --aiba-color-teal-90: hsl(178.89999999999998, 100%, 20.6%);
  --aiba-color-teal-100: hsl(176.5, 100%, 16.9%);
  --aiba-color-green-0: hsl(78.30000000000001, 59%, 92.4%);
  --aiba-color-green-10: hsl(82.5, 55.6%, 85.9%);
  --aiba-color-green-20: hsl(86.30000000000001, 55.3%, 79.8%);
  --aiba-color-green-30: hsl(90.39999999999998, 52.6%, 73.5%);
  --aiba-color-green-40: hsl(95.30000000000001, 50.9%, 67.3%);
  --aiba-color-green-50: hsl(98.80000000000001, 49.7%, 61%);
  --aiba-color-green-60: hsl(103.19999999999999, 48.1%, 54.7%);
  --aiba-color-green-70: hsl(111.5, 46.1%, 48%);
  --aiba-color-green-80: hsl(120, 52.4%, 41.2%);
  --aiba-color-green-90: hsl(127.60000000000002, 58.9%, 34.3%);
  --aiba-color-green-100: hsl(136.3, 65.7%, 27.5%);
  --aiba-color-green-101: hsl(178, 93.6%, 18.4%);
  --aiba-color-clay-0: hsl(15.800000000000011, 42.2%, 91.2%);
  --aiba-color-clay-10: hsl(19.399999999999977, 46.3%, 86.9%);
  --aiba-color-clay-20: hsl(20.899999999999977, 49.4%, 82.9%);
  --aiba-color-clay-30: hsl(21.899999999999977, 48.1%, 78.8%);
  --aiba-color-clay-40: hsl(22.30000000000001, 48.4%, 74.9%);
  --aiba-color-clay-50: hsl(22.80000000000001, 48.3%, 71.2%);
  --aiba-color-clay-60: hsl(25.100000000000023, 46.7%, 66.9%);
  --aiba-color-clay-70: hsl(22.899999999999977, 35.8%, 58.4%);
  --aiba-color-clay-80: hsl(21.399999999999977, 27.6%, 50.2%);
  --aiba-color-clay-90: hsl(18.899999999999977, 26.8%, 41.8%);
  --aiba-color-clay-100: hsl(18.600000000000023, 24.7%, 33.3%);
  --aiba-color-clay-101: hsl(10.600000000000023, 37.8%, 91.2%);
  --aiba-color-clay-102: hsl(10.899999999999977, 35.5%, 93.9%);
  --aiba-color-rose-0: hsl(338.79999999999995, 48.6%, 93.1%);
  --aiba-color-rose-10: hsl(341.4, 46%, 87.6%);
  --aiba-color-rose-20: hsl(341.4, 45.7%, 82%);
  --aiba-color-rose-30: hsl(341.9, 43.8%, 76.3%);
  --aiba-color-rose-40: hsl(343.79999999999995, 42.3%, 70.8%);
  --aiba-color-rose-50: hsl(346, 41.2%, 65.3%);
  --aiba-color-rose-60: hsl(346.79999999999995, 39.8%, 59.6%);
  --aiba-color-rose-70: hsl(344.79999999999995, 31.5%, 49.2%);
  --aiba-color-rose-80: hsl(342.9, 35.4%, 38.8%);
  --aiba-color-rose-90: hsl(340.29999999999995, 40.3%, 28.2%);
  --aiba-color-rose-100: hsl(338.4, 44.6%, 22%);
  --aiba-color-lilac-0: hsl(307.5, 33.3%, 95.3%);
  --aiba-color-lilac-10: hsl(310, 27.3%, 91.4%);
  --aiba-color-lilac-20: hsl(310.6, 28.8%, 88.4%);
  --aiba-color-lilac-30: hsl(310, 30.8%, 84.7%);
  --aiba-color-lilac-40: hsl(300, 28.2%, 77.1%);
  --aiba-color-lilac-50: hsl(293.6, 30.7%, 70%);
  --aiba-color-lilac-60: hsl(292.9, 30.9%, 62.5%);
  --aiba-color-lilac-70: hsl(292.79999999999995, 24.4%, 53.3%);
  --aiba-color-lilac-80: hsl(293.20000000000005, 23.8%, 43.7%);
  --aiba-color-lilac-90: hsl(291.79999999999995, 29.1%, 34.3%);
  --aiba-color-lilac-100: hsl(291.1, 37%, 24.9%);
  --aiba-color-pigeon-0: hsl(226.20000000000005, 41.9%, 93.9%);
  --aiba-color-pigeon-10: hsl(227.5, 42.9%, 89%);
  --aiba-color-pigeon-20: hsl(227.60000000000002, 41.5%, 83.9%);
  --aiba-color-pigeon-30: hsl(228.60000000000002, 38.9%, 78.8%);
  --aiba-color-pigeon-40: hsl(230.60000000000002, 38.3%, 73.9%);
  --aiba-color-pigeon-50: hsl(230.79999999999995, 37.1%, 68.8%);
  --aiba-color-pigeon-60: hsl(232.70000000000005, 35.9%, 63.9%);
  --aiba-color-pigeon-70: hsl(239.10000000000002, 29.8%, 55.9%);
  --aiba-color-pigeon-80: hsl(244.60000000000002, 26.5%, 48%);
  --aiba-color-pigeon-90: hsl(251.60000000000002, 30.4%, 40%);
  --aiba-color-pigeon-100: hsl(257.5, 33.7%, 32%);
  --aiba-color-neptune-0: hsl(176, 29.4%, 90%);
  --aiba-color-neptune-10: hsl(180, 31.6%, 85.1%);
  --aiba-color-neptune-20: hsl(178.29999999999995, 34.7%, 80.2%);
  --aiba-color-neptune-30: hsl(180, 34.4%, 74.9%);
  --aiba-color-neptune-40: hsl(182.29999999999995, 34.6%, 70%);
  --aiba-color-neptune-50: hsl(184, 33.7%, 65.1%);
  --aiba-color-neptune-60: hsl(184.39999999999998, 33.3%, 60%);
  --aiba-color-neptune-70: hsl(182.70000000000005, 27.5%, 52.9%);
  --aiba-color-neptune-80: hsl(180, 25.3%, 45.7%);
  --aiba-color-neptune-90: hsl(178.79999999999995, 24.9%, 38.6%);
  --aiba-color-neptune-100: hsl(178.20000000000005, 21.2%, 31.4%);
  --aiba-color-olive-0: hsl(95, 33.3%, 92.9%);
  --aiba-color-olive-10: hsl(96, 30.3%, 87.1%);
  --aiba-color-olive-20: hsl(98.60000000000002, 29.8%, 81.6%);
  --aiba-color-olive-30: hsl(100, 29%, 75.7%);
  --aiba-color-olive-40: hsl(101.89999999999998, 28.1%, 70%);
  --aiba-color-olive-50: hsl(103.19999999999999, 27.5%, 64.3%);
  --aiba-color-olive-60: hsl(103.89999999999998, 26.4%, 58.4%);
  --aiba-color-olive-70: hsl(102.19999999999999, 22%, 48.2%);
  --aiba-color-olive-80: hsl(100, 24.7%, 38%);
  --aiba-color-olive-90: hsl(97.5, 28.2%, 27.8%);
  --aiba-color-olive-100: hsl(97.69999999999999, 32.7%, 21%);
  --aiba-color-primary-hover: hsl(329.29999999999995, 95.2%, 50.6%);
  --aiba-color-primary-active: hsl(329.29999999999995, 100%, 39.8%);
  --aiba-color-focus: hsl(215.60000000000002, 100%, 62%);
  --aiba-color-text-standard: hsl(0, 0%, 9.8%);
  --aiba-color-text-additional: hsl(0, 0%, 40%);
  --aiba-color-text-link: hsl(227.39999999999998, 89%, 46.3%);
  --aiba-color-text-link-hover: hsl(236.5, 100%, 37.5%);
  --aiba-color-text-link-active: hsl(220, 100%, 56.5%);
  --aiba-color-text-link-visited: hsl(227.39999999999998, 89%, 46.3%);
  --aiba-color-text-info: hsl(227.39999999999998, 89%, 46.3%);
  --aiba-color-text-disabled: hsl(0, 0%, 49.8%);
  --aiba-color-text-success: hsl(136.3, 65.7%, 27.5%);
  --aiba-color-text-error: hsl(349.70000000000005, 69%, 50.6%);
  --aiba-color-background-standard: hsl(0, 0%, 100%);
  --aiba-color-background-light: hsl(0, 0%, 94.9%);
  --aiba-color-background-darker: hsl(0, 0%, 80%);
  --aiba-color-background-overlay: hsla(0, 0%, 42.4%, 0.7);
  --aiba-color-background-disabled: hsl(0, 0%, 80%);
  --aiba-color-background-success: hsl(136.3, 65.7%, 27.5%);
  --aiba-color-background-error: hsl(349.70000000000005, 69%, 50.6%);
  --aiba-color-functional-red: hsl(349.70000000000005, 69%, 50.6%);
  --aiba-color-functional-green: hsl(136.3, 65.7%, 27.5%);
  --aiba-color-functional-blue: hsl(227.39999999999998, 89%, 46.3%);
  /* SHADOW */
  --aiba-shadow-level-0: 0px 0.125rem 0.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.0625rem 0.125rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-1: 0px 0.25rem 1rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.125rem 0.25rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-2: 0px 0.5rem 2rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.25rem 0.5rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-3: 0px 0.75rem 3rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.375rem 0.75rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-4: 0px 1rem 4rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.5rem 1rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-5: 0px 1.25rem 5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.625rem 1.25rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-1-hover: 0px 0.375rem 1.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.1875rem 0.375rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-1-active: 0px 0.125rem 0.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.0625rem 0.125rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-2-hover: 0px 0.625rem 2.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.3125rem 0.625rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-2-active: 0px 0.375rem 1.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.1875rem 0.375rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-3-hover: 0px 0.875rem 3.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.4375rem 0.875rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-3-active: 0px 0.625rem 2.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.3125rem 0.625rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-4-hover: 0px 1.125rem 4.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.5625rem 1.125rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-4-active: 0px 0.875rem 3.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.4375rem 0.875rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-5-hover: 0px 1.375rem 5.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.6875rem 1.375rem 0px hsla(0, 0%, 0%, 0.1);
  --aiba-shadow-level-5-active: 0px 1.125rem 4.5rem 0px hsla(0, 0%, 0%, 0.1), 0px 0.5625rem 1.125rem 0px hsla(0, 0%, 0%, 0.1);
  /* RADIUS */
  --aiba-radius-1: 0.0625rem;
  --aiba-radius-2: 0.125rem;
  --aiba-radius-4: 0.25rem;
  --aiba-radius-8: 0.5rem;
  --aiba-radius-12: 0.75rem;
  /* OPACITY */
  --aiba-opacity-50: 0.5;
  /* MOTION */
  --aiba-motion-duration-immediate: 100ms;
  --aiba-motion-duration-fast: 200ms;
  --aiba-motion-duration-slower: 600ms;
  --aiba-motion-duration-deliberate: 800ms;
  --aiba-motion-easing-standard: cubic-bezier(0.42, 0, 0.58, 1);
  --aiba-motion-easing-enter: cubic-bezier(0.390, 0.575, 0.565, 1);
  /* Z-INDEX */
  --aiba-z-index-10: 10;
  --aiba-z-index-20: 20;
  --aiba-z-index-30: 30;
  --aiba-z-index-40: 40;
  --aiba-z-index-50: 50;
  --aiba-z-index-60: 60;
  --aiba-z-index-70: 70;
  /* GRID */
  --aiba-grid-break-points-sm: --mq-sm;
  --aiba-grid-break-points-md: --mq-md;
  --aiba-grid-break-points-lg: --mq-lg;
  /* GRID-GAP */
  --aiba-grid-gap-1: 1;
  --aiba-grid-gap-2: 2;
  --aiba-grid-gap-4: 4;
  --aiba-grid-gap-8: 8;
  --aiba-grid-gap-12: 12;
  --aiba-grid-gap-16: 16;
  --aiba-grid-gap-24: 24;
  --aiba-grid-gap-32: 32;
  --aiba-grid-gap-40: 40;
  --aiba-grid-gap-48: 48;
  --aiba-grid-gap-64: 64;
  --aiba-grid-gap-80: 80;
  /* GRID-ITEM-ORDER */
  --aiba-grid-item-order-orders-1: 1;
  --aiba-grid-item-order-orders-2: 2;
  --aiba-grid-item-order-orders-3: 3;
  --aiba-grid-item-order-orders-4: 4;
  --aiba-grid-item-order-orders-5: 5;
  --aiba-grid-item-order-orders-6: 6;
  --aiba-grid-item-order-orders-7: 7;
  --aiba-grid-item-order-orders-8: 8;
  --aiba-grid-item-order-orders-9: 9;
  --aiba-grid-item-order-orders-10: 10;
  /* PADDING */
  --aiba-padding-padding-0: 0;
  --aiba-padding-padding-1: 1;
  --aiba-padding-padding-2: 2;
  --aiba-padding-padding-3: 3;
  --aiba-padding-padding-4: 4;
  --aiba-padding-padding-5: 5;
  --aiba-padding-padding-6: 6;
  --aiba-padding-padding-7: 7;
  --aiba-padding-padding-8: 8;
  --aiba-padding-padding-9: 9;
  --aiba-padding-padding-10: 10;
  --aiba-padding-padding-11: 11;
  --aiba-padding-padding-12: 12;
  --aiba-padding-padding-13: 13;
  --aiba-padding-padding-14: 14;
  --aiba-padding-padding-15: 15;
  --aiba-padding-padding-16: 16;
  --aiba-padding-padding-17: 17;
  --aiba-padding-padding-18: 18;
  --aiba-padding-padding-19: 19;
  --aiba-padding-padding-20: 20;
  /* MARGIN */
  --aiba-margin-margin-0: 0;
  --aiba-margin-margin-1: 1;
  --aiba-margin-margin-2: 2;
  --aiba-margin-margin-3: 3;
  --aiba-margin-margin-4: 4;
  --aiba-margin-margin-5: 5;
  --aiba-margin-margin-6: 6;
  --aiba-margin-margin-7: 7;
  --aiba-margin-margin-8: 8;
  --aiba-margin-margin-9: 9;
  --aiba-margin-margin-10: 10;
  /* WIDTH */
  --aiba-width-width-0: 0;
  --aiba-width-width-1: 1;
  --aiba-width-width-2: 2;
  --aiba-width-width-3: 3;
  --aiba-width-width-4: 4;
  --aiba-width-width-5: 5;
  --aiba-width-width-6: 6;
  --aiba-width-width-7: 7;
  --aiba-width-width-8: 8;
  --aiba-width-width-9: 9;
  --aiba-width-width-10: 10;
  --aiba-width-width-11: 11;
  --aiba-width-width-12: 12;
  --aiba-width-width-13: 13;
  --aiba-width-width-14: 14;
  --aiba-width-width-15: 15;
  --aiba-width-width-16: 16;
  --aiba-width-width-17: 17;
  --aiba-width-width-18: 18;
  --aiba-width-width-19: 19;
  --aiba-width-width-20: 20;
  --aiba-width-width-30: 30;
  --aiba-width-width-40: 40;
  --aiba-width-width-50: 50;
  --aiba-width-width-60: 60;
  --aiba-width-width-70: 70;
  --aiba-width-width-80: 80;
  --aiba-width-width-90: 90;
  --aiba-width-width-100: 100;
  --aiba-width-width-auto: auto;
  /* TEXT-ALIGN */
  --aiba-text-align-0-0: l;
  --aiba-text-align-0-1: e;
  --aiba-text-align-0-2: f;
  --aiba-text-align-0-3: t;
  --aiba-text-align-1-0: r;
  --aiba-text-align-1-1: i;
  --aiba-text-align-1-2: g;
  --aiba-text-align-1-3: h;
  --aiba-text-align-1-4: t;
  --aiba-text-align-2-0: c;
  --aiba-text-align-2-1: e;
  --aiba-text-align-2-2: n;
  --aiba-text-align-2-3: t;
  --aiba-text-align-2-4: e;
  --aiba-text-align-2-5: r ;
}

/* FONT VARIANT CLASSES */
.aiba-font-variant-body {
  font-family: var(--aiba-font-variant-body-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-body-size, 1rem);
  font-weight: var(--aiba-font-variant-body-weight, 400);
  line-height: var(--aiba-font-variant-body-line-height, 150%);
  letter-spacing: var(--aiba-font-variant-body-letter-spacing, normal);
}

.aiba-font-variant-body-short {
  font-family: var(--aiba-font-variant-body-short-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-body-short-size, 1rem);
  font-weight: var(--aiba-font-variant-body-short-weight, 400);
  line-height: var(--aiba-font-variant-body-short-line-height, 125%);
  letter-spacing: var(--aiba-font-variant-body-short-letter-spacing, normal);
}

.aiba-font-variant-body-large {
  font-family: var(--aiba-font-variant-body-large-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-body-large-size, 1.25rem);
  font-weight: var(--aiba-font-variant-body-large-weight, 400);
  line-height: var(--aiba-font-variant-body-large-line-height, 160%);
  letter-spacing: var(--aiba-font-variant-body-large-letter-spacing, normal);
}

.aiba-font-variant-smaller {
  font-family: var(--aiba-font-variant-smaller-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-smaller-size, 0.75rem);
  font-weight: var(--aiba-font-variant-smaller-weight, 400);
  line-height: var(--aiba-font-variant-smaller-line-height, 125%);
  letter-spacing: var(--aiba-font-variant-smaller-letter-spacing, normal);
}

.aiba-font-variant-label {
  font-family: var(--aiba-font-variant-label-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-label-size, 0.75rem);
  font-weight: var(--aiba-font-variant-label-weight, 400);
  line-height: var(--aiba-font-variant-label-line-height, 120%);
  letter-spacing: var(--aiba-font-variant-label-letter-spacing, normal);
}

.aiba-font-variant-caption {
  font-family: var(--aiba-font-variant-caption-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-caption-size, 0.75rem);
  font-weight: var(--aiba-font-variant-caption-weight, 400);
  line-height: var(--aiba-font-variant-caption-line-height, 133%);
  letter-spacing: var(--aiba-font-variant-caption-letter-spacing, normal);
}

.aiba-font-variant-heading-8 {
  font-family: var(--aiba-font-variant-heading-8-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-heading-8-size, 1.5rem);
  font-weight: var(--aiba-font-variant-heading-8-weight, 400);
  line-height: var(--aiba-font-variant-heading-8-line-height, 133%);
  letter-spacing: var(--aiba-font-variant-heading-8-letter-spacing, normal);
}

.aiba-font-variant-heading-7 {
  font-family: var(--aiba-font-variant-heading-7-family, Montserrat, sans-serif);
  font-size: var(--aiba-font-variant-heading-7-size, 1.5rem);
  font-weight: var(--aiba-font-variant-heading-7-weight, 700);
  line-height: var(--aiba-font-variant-heading-7-line-height, 133%);
  letter-spacing: var(--aiba-font-variant-heading-7-letter-spacing, normal);
}

.aiba-font-variant-heading-6 {
  font-family: var(--aiba-font-variant-heading-6-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-heading-6-size, 1rem);
  font-weight: var(--aiba-font-variant-heading-6-weight, 700);
  line-height: var(--aiba-font-variant-heading-6-line-height, 150%);
  letter-spacing: var(--aiba-font-variant-heading-6-letter-spacing, normal);
}

.aiba-font-variant-heading-5 {
  font-family: var(--aiba-font-variant-heading-5-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-heading-5-size, 1.25rem);
  font-weight: var(--aiba-font-variant-heading-5-weight, 800);
  line-height: var(--aiba-font-variant-heading-5-line-height, 125%);
  letter-spacing: var(--aiba-font-variant-heading-5-letter-spacing, normal);
}

.aiba-font-variant-heading-4 {
  font-family: var(--aiba-font-variant-heading-4-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-heading-4-size, 1.5rem);
  font-weight: var(--aiba-font-variant-heading-4-weight, 800);
  line-height: var(--aiba-font-variant-heading-4-line-height, 133%);
  letter-spacing: var(--aiba-font-variant-heading-4-letter-spacing, normal);
}

.aiba-font-variant-heading-3 {
  font-family: var(--aiba-font-variant-heading-3-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-heading-3-size, 2rem);
  font-weight: var(--aiba-font-variant-heading-3-weight, 400);
  line-height: var(--aiba-font-variant-heading-3-line-height, 125%);
  letter-spacing: var(--aiba-font-variant-heading-3-letter-spacing, normal);
}

.aiba-font-variant-heading-2 {
  font-family: var(--aiba-font-variant-heading-2-family, Montserrat, sans-serif);
  font-size: var(--aiba-font-variant-heading-2-size, 2rem);
  font-weight: var(--aiba-font-variant-heading-2-weight, 700);
  line-height: var(--aiba-font-variant-heading-2-line-height, 125%);
  letter-spacing: var(--aiba-font-variant-heading-2-letter-spacing, normal);
}

.aiba-font-variant-heading-1 {
  font-family: var(--aiba-font-variant-heading-1-family, roboto, sans-serif);
  font-size: var(--aiba-font-variant-heading-1-size, 3.5rem);
  font-weight: var(--aiba-font-variant-heading-1-weight, 800);
  line-height: var(--aiba-font-variant-heading-1-line-height, 114%);
  letter-spacing: var(--aiba-font-variant-heading-1-letter-spacing, normal);
}

.grid-item-order-1 {
  order: 1;
}

.grid-item-order-2 {
  order: 2;
}

.grid-item-order-3 {
  order: 3;
}

.grid-item-order-4 {
  order: 4;
}

.grid-item-order-5 {
  order: 5;
}

.grid-item-order-6 {
  order: 6;
}

.grid-item-order-7 {
  order: 7;
}

.grid-item-order-8 {
  order: 8;
}

.grid-item-order-9 {
  order: 9;
}

.grid-item-order-10 {
  order: 10;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: var(--aiba-spacing-8);
}

@media (min-width: 300px) {
  .col-sm-12 {
    grid-column: span 12;
  }
  .col-sm-11 {
    grid-column: span 11;
  }
  .col-sm-10 {
    grid-column: span 10;
  }
  .col-sm-9 {
    grid-column: span 9;
  }
  .col-sm-8 {
    grid-column: span 8;
  }
  .col-sm-7 {
    grid-column: span 7;
  }
  .col-sm-6 {
    grid-column: span 6;
  }
  .col-sm-5 {
    grid-column: span 5;
  }
  .col-sm-4 {
    grid-column: span 4;
  }
  .col-sm-3 {
    grid-column: span 3;
  }
  .col-sm-2 {
    grid-column: span 2;
  }
  .col-sm-1 {
    grid-column: span 1;
  }
}
@media (min-width: 481px) {
  .col-md-12 {
    grid-column: span 12;
  }
  .col-md-11 {
    grid-column: span 11;
  }
  .col-md-10 {
    grid-column: span 10;
  }
  .col-md-9 {
    grid-column: span 9;
  }
  .col-md-8 {
    grid-column: span 8;
  }
  .col-md-7 {
    grid-column: span 7;
  }
  .col-md-6 {
    grid-column: span 6;
  }
  .col-md-5 {
    grid-column: span 5;
  }
  .col-md-4 {
    grid-column: span 4;
  }
  .col-md-3 {
    grid-column: span 3;
  }
  .col-md-2 {
    grid-column: span 2;
  }
  .col-md-1 {
    grid-column: span 1;
  }
}
@media (min-width: 769px) {
  .col-lg-12 {
    grid-column: span 12;
  }
  .col-lg-11 {
    grid-column: span 11;
  }
  .col-lg-10 {
    grid-column: span 10;
  }
  .col-lg-9 {
    grid-column: span 9;
  }
  .col-lg-8 {
    grid-column: span 8;
  }
  .col-lg-7 {
    grid-column: span 7;
  }
  .col-lg-6 {
    grid-column: span 6;
  }
  .col-lg-5 {
    grid-column: span 5;
  }
  .col-lg-4 {
    grid-column: span 4;
  }
  .col-lg-3 {
    grid-column: span 3;
  }
  .col-lg-2 {
    grid-column: span 2;
  }
  .col-lg-1 {
    grid-column: span 1;
  }
}
@media (min-width: 300px) {
  .max-width-sm-0 {
    max-width: 0rem;
  }
  .max-width-sm-1 {
    max-width: 1rem;
  }
  .max-width-sm-2 {
    max-width: 2rem;
  }
  .max-width-sm-3 {
    max-width: 3rem;
  }
  .max-width-sm-4 {
    max-width: 4rem;
  }
  .max-width-sm-5 {
    max-width: 5rem;
  }
  .max-width-sm-6 {
    max-width: 6rem;
  }
  .max-width-sm-7 {
    max-width: 7rem;
  }
  .max-width-sm-8 {
    max-width: 8rem;
  }
  .max-width-sm-9 {
    max-width: 9rem;
  }
  .max-width-sm-10 {
    max-width: 10rem;
  }
  .max-width-sm-11 {
    max-width: 11rem;
  }
  .max-width-sm-12 {
    max-width: 12rem;
  }
  .max-width-sm-13 {
    max-width: 13rem;
  }
  .max-width-sm-14 {
    max-width: 14rem;
  }
  .max-width-sm-15 {
    max-width: 15rem;
  }
  .max-width-sm-16 {
    max-width: 16rem;
  }
  .max-width-sm-17 {
    max-width: 17rem;
  }
  .max-width-sm-18 {
    max-width: 18rem;
  }
  .max-width-sm-19 {
    max-width: 19rem;
  }
  .max-width-sm-20 {
    max-width: 20rem;
  }
  .max-width-sm-30 {
    max-width: 30rem;
  }
  .max-width-sm-40 {
    max-width: 40rem;
  }
  .max-width-sm-50 {
    max-width: 50rem;
  }
  .max-width-sm-60 {
    max-width: 60rem;
  }
  .max-width-sm-70 {
    max-width: 70rem;
  }
  .max-width-sm-80 {
    max-width: 80rem;
  }
  .max-width-sm-90 {
    max-width: 90rem;
  }
  .max-width-sm-100 {
    max-width: 100%;
  }
  .max-width-sm-auto {
    max-width: auto;
  }
}
@media (min-width: 300px) {
  .min-width-sm-0 {
    min-width: 0rem;
  }
  .min-width-sm-1 {
    min-width: 1rem;
  }
  .min-width-sm-2 {
    min-width: 2rem;
  }
  .min-width-sm-3 {
    min-width: 3rem;
  }
  .min-width-sm-4 {
    min-width: 4rem;
  }
  .min-width-sm-5 {
    min-width: 5rem;
  }
  .min-width-sm-6 {
    min-width: 6rem;
  }
  .min-width-sm-7 {
    min-width: 7rem;
  }
  .min-width-sm-8 {
    min-width: 8rem;
  }
  .min-width-sm-9 {
    min-width: 9rem;
  }
  .min-width-sm-10 {
    min-width: 10rem;
  }
  .min-width-sm-11 {
    min-width: 11rem;
  }
  .min-width-sm-12 {
    min-width: 12rem;
  }
  .min-width-sm-13 {
    min-width: 13rem;
  }
  .min-width-sm-14 {
    min-width: 14rem;
  }
  .min-width-sm-15 {
    min-width: 15rem;
  }
  .min-width-sm-16 {
    min-width: 16rem;
  }
  .min-width-sm-17 {
    min-width: 17rem;
  }
  .min-width-sm-18 {
    min-width: 18rem;
  }
  .min-width-sm-19 {
    min-width: 19rem;
  }
  .min-width-sm-20 {
    min-width: 20rem;
  }
  .min-width-sm-30 {
    min-width: 30rem;
  }
  .min-width-sm-40 {
    min-width: 40rem;
  }
  .min-width-sm-50 {
    min-width: 50rem;
  }
  .min-width-sm-60 {
    min-width: 60rem;
  }
  .min-width-sm-70 {
    min-width: 70rem;
  }
  .min-width-sm-80 {
    min-width: 80rem;
  }
  .min-width-sm-90 {
    min-width: 90rem;
  }
  .min-width-sm-100 {
    min-width: 100%;
  }
  .min-width-sm-auto {
    min-width: auto;
  }
}
@media (min-width: 300px) {
  .width-sm-0 {
    width: 0rem;
  }
  .width-sm-1 {
    width: 1rem;
  }
  .width-sm-2 {
    width: 2rem;
  }
  .width-sm-3 {
    width: 3rem;
  }
  .width-sm-4 {
    width: 4rem;
  }
  .width-sm-5 {
    width: 5rem;
  }
  .width-sm-6 {
    width: 6rem;
  }
  .width-sm-7 {
    width: 7rem;
  }
  .width-sm-8 {
    width: 8rem;
  }
  .width-sm-9 {
    width: 9rem;
  }
  .width-sm-10 {
    width: 10rem;
  }
  .width-sm-11 {
    width: 11rem;
  }
  .width-sm-12 {
    width: 12rem;
  }
  .width-sm-13 {
    width: 13rem;
  }
  .width-sm-14 {
    width: 14rem;
  }
  .width-sm-15 {
    width: 15rem;
  }
  .width-sm-16 {
    width: 16rem;
  }
  .width-sm-17 {
    width: 17rem;
  }
  .width-sm-18 {
    width: 18rem;
  }
  .width-sm-19 {
    width: 19rem;
  }
  .width-sm-20 {
    width: 20rem;
  }
  .width-sm-30 {
    width: 30rem;
  }
  .width-sm-40 {
    width: 40rem;
  }
  .width-sm-50 {
    width: 50rem;
  }
  .width-sm-60 {
    width: 60rem;
  }
  .width-sm-70 {
    width: 70rem;
  }
  .width-sm-80 {
    width: 80rem;
  }
  .width-sm-90 {
    width: 90rem;
  }
  .width-sm-100 {
    width: 100%;
  }
  .width-sm-auto {
    width: auto;
  }
}
@media (min-width: 481px) {
  .max-width-md-0 {
    max-width: 0rem;
  }
  .max-width-md-1 {
    max-width: 1rem;
  }
  .max-width-md-2 {
    max-width: 2rem;
  }
  .max-width-md-3 {
    max-width: 3rem;
  }
  .max-width-md-4 {
    max-width: 4rem;
  }
  .max-width-md-5 {
    max-width: 5rem;
  }
  .max-width-md-6 {
    max-width: 6rem;
  }
  .max-width-md-7 {
    max-width: 7rem;
  }
  .max-width-md-8 {
    max-width: 8rem;
  }
  .max-width-md-9 {
    max-width: 9rem;
  }
  .max-width-md-10 {
    max-width: 10rem;
  }
  .max-width-md-11 {
    max-width: 11rem;
  }
  .max-width-md-12 {
    max-width: 12rem;
  }
  .max-width-md-13 {
    max-width: 13rem;
  }
  .max-width-md-14 {
    max-width: 14rem;
  }
  .max-width-md-15 {
    max-width: 15rem;
  }
  .max-width-md-16 {
    max-width: 16rem;
  }
  .max-width-md-17 {
    max-width: 17rem;
  }
  .max-width-md-18 {
    max-width: 18rem;
  }
  .max-width-md-19 {
    max-width: 19rem;
  }
  .max-width-md-20 {
    max-width: 20rem;
  }
  .max-width-md-30 {
    max-width: 30rem;
  }
  .max-width-md-40 {
    max-width: 40rem;
  }
  .max-width-md-50 {
    max-width: 50rem;
  }
  .max-width-md-60 {
    max-width: 60rem;
  }
  .max-width-md-70 {
    max-width: 70rem;
  }
  .max-width-md-80 {
    max-width: 80rem;
  }
  .max-width-md-90 {
    max-width: 90rem;
  }
  .max-width-md-100 {
    max-width: 100%;
  }
  .max-width-md-auto {
    max-width: auto;
  }
}
@media (min-width: 481px) {
  .min-width-md-0 {
    min-width: 0rem;
  }
  .min-width-md-1 {
    min-width: 1rem;
  }
  .min-width-md-2 {
    min-width: 2rem;
  }
  .min-width-md-3 {
    min-width: 3rem;
  }
  .min-width-md-4 {
    min-width: 4rem;
  }
  .min-width-md-5 {
    min-width: 5rem;
  }
  .min-width-md-6 {
    min-width: 6rem;
  }
  .min-width-md-7 {
    min-width: 7rem;
  }
  .min-width-md-8 {
    min-width: 8rem;
  }
  .min-width-md-9 {
    min-width: 9rem;
  }
  .min-width-md-10 {
    min-width: 10rem;
  }
  .min-width-md-11 {
    min-width: 11rem;
  }
  .min-width-md-12 {
    min-width: 12rem;
  }
  .min-width-md-13 {
    min-width: 13rem;
  }
  .min-width-md-14 {
    min-width: 14rem;
  }
  .min-width-md-15 {
    min-width: 15rem;
  }
  .min-width-md-16 {
    min-width: 16rem;
  }
  .min-width-md-17 {
    min-width: 17rem;
  }
  .min-width-md-18 {
    min-width: 18rem;
  }
  .min-width-md-19 {
    min-width: 19rem;
  }
  .min-width-md-20 {
    min-width: 20rem;
  }
  .min-width-md-30 {
    min-width: 30rem;
  }
  .min-width-md-40 {
    min-width: 40rem;
  }
  .min-width-md-50 {
    min-width: 50rem;
  }
  .min-width-md-60 {
    min-width: 60rem;
  }
  .min-width-md-70 {
    min-width: 70rem;
  }
  .min-width-md-80 {
    min-width: 80rem;
  }
  .min-width-md-90 {
    min-width: 90rem;
  }
  .min-width-md-100 {
    min-width: 100%;
  }
  .min-width-md-auto {
    min-width: auto;
  }
}
@media (min-width: 481px) {
  .width-md-0 {
    width: 0rem;
  }
  .width-md-1 {
    width: 1rem;
  }
  .width-md-2 {
    width: 2rem;
  }
  .width-md-3 {
    width: 3rem;
  }
  .width-md-4 {
    width: 4rem;
  }
  .width-md-5 {
    width: 5rem;
  }
  .width-md-6 {
    width: 6rem;
  }
  .width-md-7 {
    width: 7rem;
  }
  .width-md-8 {
    width: 8rem;
  }
  .width-md-9 {
    width: 9rem;
  }
  .width-md-10 {
    width: 10rem;
  }
  .width-md-11 {
    width: 11rem;
  }
  .width-md-12 {
    width: 12rem;
  }
  .width-md-13 {
    width: 13rem;
  }
  .width-md-14 {
    width: 14rem;
  }
  .width-md-15 {
    width: 15rem;
  }
  .width-md-16 {
    width: 16rem;
  }
  .width-md-17 {
    width: 17rem;
  }
  .width-md-18 {
    width: 18rem;
  }
  .width-md-19 {
    width: 19rem;
  }
  .width-md-20 {
    width: 20rem;
  }
  .width-md-30 {
    width: 30rem;
  }
  .width-md-40 {
    width: 40rem;
  }
  .width-md-50 {
    width: 50rem;
  }
  .width-md-60 {
    width: 60rem;
  }
  .width-md-70 {
    width: 70rem;
  }
  .width-md-80 {
    width: 80rem;
  }
  .width-md-90 {
    width: 90rem;
  }
  .width-md-100 {
    width: 100%;
  }
  .width-md-auto {
    width: auto;
  }
}
@media (min-width: 769px) {
  .max-width-lg-0 {
    max-width: 0rem;
  }
  .max-width-lg-1 {
    max-width: 1rem;
  }
  .max-width-lg-2 {
    max-width: 2rem;
  }
  .max-width-lg-3 {
    max-width: 3rem;
  }
  .max-width-lg-4 {
    max-width: 4rem;
  }
  .max-width-lg-5 {
    max-width: 5rem;
  }
  .max-width-lg-6 {
    max-width: 6rem;
  }
  .max-width-lg-7 {
    max-width: 7rem;
  }
  .max-width-lg-8 {
    max-width: 8rem;
  }
  .max-width-lg-9 {
    max-width: 9rem;
  }
  .max-width-lg-10 {
    max-width: 10rem;
  }
  .max-width-lg-11 {
    max-width: 11rem;
  }
  .max-width-lg-12 {
    max-width: 12rem;
  }
  .max-width-lg-13 {
    max-width: 13rem;
  }
  .max-width-lg-14 {
    max-width: 14rem;
  }
  .max-width-lg-15 {
    max-width: 15rem;
  }
  .max-width-lg-16 {
    max-width: 16rem;
  }
  .max-width-lg-17 {
    max-width: 17rem;
  }
  .max-width-lg-18 {
    max-width: 18rem;
  }
  .max-width-lg-19 {
    max-width: 19rem;
  }
  .max-width-lg-20 {
    max-width: 20rem;
  }
  .max-width-lg-30 {
    max-width: 30rem;
  }
  .max-width-lg-40 {
    max-width: 40rem;
  }
  .max-width-lg-50 {
    max-width: 50rem;
  }
  .max-width-lg-60 {
    max-width: 60rem;
  }
  .max-width-lg-70 {
    max-width: 70rem;
  }
  .max-width-lg-80 {
    max-width: 80rem;
  }
  .max-width-lg-90 {
    max-width: 90rem;
  }
  .max-width-lg-100 {
    max-width: 100%;
  }
  .max-width-lg-auto {
    max-width: auto;
  }
}
@media (min-width: 769px) {
  .min-width-lg-0 {
    min-width: 0rem;
  }
  .min-width-lg-1 {
    min-width: 1rem;
  }
  .min-width-lg-2 {
    min-width: 2rem;
  }
  .min-width-lg-3 {
    min-width: 3rem;
  }
  .min-width-lg-4 {
    min-width: 4rem;
  }
  .min-width-lg-5 {
    min-width: 5rem;
  }
  .min-width-lg-6 {
    min-width: 6rem;
  }
  .min-width-lg-7 {
    min-width: 7rem;
  }
  .min-width-lg-8 {
    min-width: 8rem;
  }
  .min-width-lg-9 {
    min-width: 9rem;
  }
  .min-width-lg-10 {
    min-width: 10rem;
  }
  .min-width-lg-11 {
    min-width: 11rem;
  }
  .min-width-lg-12 {
    min-width: 12rem;
  }
  .min-width-lg-13 {
    min-width: 13rem;
  }
  .min-width-lg-14 {
    min-width: 14rem;
  }
  .min-width-lg-15 {
    min-width: 15rem;
  }
  .min-width-lg-16 {
    min-width: 16rem;
  }
  .min-width-lg-17 {
    min-width: 17rem;
  }
  .min-width-lg-18 {
    min-width: 18rem;
  }
  .min-width-lg-19 {
    min-width: 19rem;
  }
  .min-width-lg-20 {
    min-width: 20rem;
  }
  .min-width-lg-30 {
    min-width: 30rem;
  }
  .min-width-lg-40 {
    min-width: 40rem;
  }
  .min-width-lg-50 {
    min-width: 50rem;
  }
  .min-width-lg-60 {
    min-width: 60rem;
  }
  .min-width-lg-70 {
    min-width: 70rem;
  }
  .min-width-lg-80 {
    min-width: 80rem;
  }
  .min-width-lg-90 {
    min-width: 90rem;
  }
  .min-width-lg-100 {
    min-width: 100%;
  }
  .min-width-lg-auto {
    min-width: auto;
  }
}
@media (min-width: 769px) {
  .width-lg-0 {
    width: 0rem;
  }
  .width-lg-1 {
    width: 1rem;
  }
  .width-lg-2 {
    width: 2rem;
  }
  .width-lg-3 {
    width: 3rem;
  }
  .width-lg-4 {
    width: 4rem;
  }
  .width-lg-5 {
    width: 5rem;
  }
  .width-lg-6 {
    width: 6rem;
  }
  .width-lg-7 {
    width: 7rem;
  }
  .width-lg-8 {
    width: 8rem;
  }
  .width-lg-9 {
    width: 9rem;
  }
  .width-lg-10 {
    width: 10rem;
  }
  .width-lg-11 {
    width: 11rem;
  }
  .width-lg-12 {
    width: 12rem;
  }
  .width-lg-13 {
    width: 13rem;
  }
  .width-lg-14 {
    width: 14rem;
  }
  .width-lg-15 {
    width: 15rem;
  }
  .width-lg-16 {
    width: 16rem;
  }
  .width-lg-17 {
    width: 17rem;
  }
  .width-lg-18 {
    width: 18rem;
  }
  .width-lg-19 {
    width: 19rem;
  }
  .width-lg-20 {
    width: 20rem;
  }
  .width-lg-30 {
    width: 30rem;
  }
  .width-lg-40 {
    width: 40rem;
  }
  .width-lg-50 {
    width: 50rem;
  }
  .width-lg-60 {
    width: 60rem;
  }
  .width-lg-70 {
    width: 70rem;
  }
  .width-lg-80 {
    width: 80rem;
  }
  .width-lg-90 {
    width: 90rem;
  }
  .width-lg-100 {
    width: 100%;
  }
  .width-lg-auto {
    width: auto;
  }
}
@media (min-width: 300px) {
  .justify-center-sm {
    justify-content: center;
  }
}
@media (min-width: 300px) {
  .justify-start-sm {
    justify-content: start;
  }
}
@media (min-width: 300px) {
  .justify-end-sm {
    justify-content: end;
  }
}
@media (min-width: 300px) {
  .justify-right-sm {
    justify-content: right;
  }
}
@media (min-width: 300px) {
  .justify-left-sm {
    justify-content: left;
  }
}
@media (min-width: 481px) {
  .justify-center-md {
    justify-content: center;
  }
}
@media (min-width: 481px) {
  .justify-start-md {
    justify-content: start;
  }
}
@media (min-width: 481px) {
  .justify-end-md {
    justify-content: end;
  }
}
@media (min-width: 481px) {
  .justify-right-md {
    justify-content: right;
  }
}
@media (min-width: 481px) {
  .justify-left-md {
    justify-content: left;
  }
}
@media (min-width: 769px) {
  .justify-center-lg {
    justify-content: center;
  }
}
@media (min-width: 769px) {
  .justify-start-lg {
    justify-content: start;
  }
}
@media (min-width: 769px) {
  .justify-end-lg {
    justify-content: end;
  }
}
@media (min-width: 769px) {
  .justify-right-lg {
    justify-content: right;
  }
}
@media (min-width: 769px) {
  .justify-left-lg {
    justify-content: left;
  }
}
@media (min-width: 300px) {
  .padding-sm-0 {
    padding: 0rem;
  }
  .padding-sm-1 {
    padding: 1rem;
  }
  .padding-sm-2 {
    padding: 2rem;
  }
  .padding-sm-3 {
    padding: 3rem;
  }
  .padding-sm-4 {
    padding: 4rem;
  }
  .padding-sm-5 {
    padding: 5rem;
  }
  .padding-sm-6 {
    padding: 6rem;
  }
  .padding-sm-7 {
    padding: 7rem;
  }
  .padding-sm-8 {
    padding: 8rem;
  }
  .padding-sm-9 {
    padding: 9rem;
  }
  .padding-sm-10 {
    padding: 10rem;
  }
  .padding-sm-11 {
    padding: 11rem;
  }
  .padding-sm-12 {
    padding: 12rem;
  }
  .padding-sm-13 {
    padding: 13rem;
  }
  .padding-sm-14 {
    padding: 14rem;
  }
  .padding-sm-15 {
    padding: 15rem;
  }
  .padding-sm-16 {
    padding: 16rem;
  }
  .padding-sm-17 {
    padding: 17rem;
  }
  .padding-sm-18 {
    padding: 18rem;
  }
  .padding-sm-19 {
    padding: 19rem;
  }
  .padding-sm-20 {
    padding: 20rem;
  }
}
@media (min-width: 481px) {
  .padding-md-0 {
    padding: 0rem;
  }
  .padding-md-1 {
    padding: 1rem;
  }
  .padding-md-2 {
    padding: 2rem;
  }
  .padding-md-3 {
    padding: 3rem;
  }
  .padding-md-4 {
    padding: 4rem;
  }
  .padding-md-5 {
    padding: 5rem;
  }
  .padding-md-6 {
    padding: 6rem;
  }
  .padding-md-7 {
    padding: 7rem;
  }
  .padding-md-8 {
    padding: 8rem;
  }
  .padding-md-9 {
    padding: 9rem;
  }
  .padding-md-10 {
    padding: 10rem;
  }
  .padding-md-11 {
    padding: 11rem;
  }
  .padding-md-12 {
    padding: 12rem;
  }
  .padding-md-13 {
    padding: 13rem;
  }
  .padding-md-14 {
    padding: 14rem;
  }
  .padding-md-15 {
    padding: 15rem;
  }
  .padding-md-16 {
    padding: 16rem;
  }
  .padding-md-17 {
    padding: 17rem;
  }
  .padding-md-18 {
    padding: 18rem;
  }
  .padding-md-19 {
    padding: 19rem;
  }
  .padding-md-20 {
    padding: 20rem;
  }
}
@media (min-width: 769px) {
  .padding-lg-0 {
    padding: 0rem;
  }
  .padding-lg-1 {
    padding: 1rem;
  }
  .padding-lg-2 {
    padding: 2rem;
  }
  .padding-lg-3 {
    padding: 3rem;
  }
  .padding-lg-4 {
    padding: 4rem;
  }
  .padding-lg-5 {
    padding: 5rem;
  }
  .padding-lg-6 {
    padding: 6rem;
  }
  .padding-lg-7 {
    padding: 7rem;
  }
  .padding-lg-8 {
    padding: 8rem;
  }
  .padding-lg-9 {
    padding: 9rem;
  }
  .padding-lg-10 {
    padding: 10rem;
  }
  .padding-lg-11 {
    padding: 11rem;
  }
  .padding-lg-12 {
    padding: 12rem;
  }
  .padding-lg-13 {
    padding: 13rem;
  }
  .padding-lg-14 {
    padding: 14rem;
  }
  .padding-lg-15 {
    padding: 15rem;
  }
  .padding-lg-16 {
    padding: 16rem;
  }
  .padding-lg-17 {
    padding: 17rem;
  }
  .padding-lg-18 {
    padding: 18rem;
  }
  .padding-lg-19 {
    padding: 19rem;
  }
  .padding-lg-20 {
    padding: 20rem;
  }
}
@media (min-width: 300px) {
  .padding-l-sm-0 {
    padding-left: 0rem;
  }
  .padding-l-sm-1 {
    padding-left: 1rem;
  }
  .padding-l-sm-2 {
    padding-left: 2rem;
  }
  .padding-l-sm-3 {
    padding-left: 3rem;
  }
  .padding-l-sm-4 {
    padding-left: 4rem;
  }
  .padding-l-sm-5 {
    padding-left: 5rem;
  }
  .padding-l-sm-6 {
    padding-left: 6rem;
  }
  .padding-l-sm-7 {
    padding-left: 7rem;
  }
  .padding-l-sm-8 {
    padding-left: 8rem;
  }
  .padding-l-sm-9 {
    padding-left: 9rem;
  }
  .padding-l-sm-10 {
    padding-left: 10rem;
  }
  .padding-l-sm-11 {
    padding-left: 11rem;
  }
  .padding-l-sm-12 {
    padding-left: 12rem;
  }
  .padding-l-sm-13 {
    padding-left: 13rem;
  }
  .padding-l-sm-14 {
    padding-left: 14rem;
  }
  .padding-l-sm-15 {
    padding-left: 15rem;
  }
  .padding-l-sm-16 {
    padding-left: 16rem;
  }
  .padding-l-sm-17 {
    padding-left: 17rem;
  }
  .padding-l-sm-18 {
    padding-left: 18rem;
  }
  .padding-l-sm-19 {
    padding-left: 19rem;
  }
  .padding-l-sm-20 {
    padding-left: 20rem;
  }
}
@media (min-width: 481px) {
  .padding-l-md-0 {
    padding-left: 0rem;
  }
  .padding-l-md-1 {
    padding-left: 1rem;
  }
  .padding-l-md-2 {
    padding-left: 2rem;
  }
  .padding-l-md-3 {
    padding-left: 3rem;
  }
  .padding-l-md-4 {
    padding-left: 4rem;
  }
  .padding-l-md-5 {
    padding-left: 5rem;
  }
  .padding-l-md-6 {
    padding-left: 6rem;
  }
  .padding-l-md-7 {
    padding-left: 7rem;
  }
  .padding-l-md-8 {
    padding-left: 8rem;
  }
  .padding-l-md-9 {
    padding-left: 9rem;
  }
  .padding-l-md-10 {
    padding-left: 10rem;
  }
  .padding-l-md-11 {
    padding-left: 11rem;
  }
  .padding-l-md-12 {
    padding-left: 12rem;
  }
  .padding-l-md-13 {
    padding-left: 13rem;
  }
  .padding-l-md-14 {
    padding-left: 14rem;
  }
  .padding-l-md-15 {
    padding-left: 15rem;
  }
  .padding-l-md-16 {
    padding-left: 16rem;
  }
  .padding-l-md-17 {
    padding-left: 17rem;
  }
  .padding-l-md-18 {
    padding-left: 18rem;
  }
  .padding-l-md-19 {
    padding-left: 19rem;
  }
  .padding-l-md-20 {
    padding-left: 20rem;
  }
}
@media (min-width: 769px) {
  .padding-l-lg-0 {
    padding-left: 0rem;
  }
  .padding-l-lg-1 {
    padding-left: 1rem;
  }
  .padding-l-lg-2 {
    padding-left: 2rem;
  }
  .padding-l-lg-3 {
    padding-left: 3rem;
  }
  .padding-l-lg-4 {
    padding-left: 4rem;
  }
  .padding-l-lg-5 {
    padding-left: 5rem;
  }
  .padding-l-lg-6 {
    padding-left: 6rem;
  }
  .padding-l-lg-7 {
    padding-left: 7rem;
  }
  .padding-l-lg-8 {
    padding-left: 8rem;
  }
  .padding-l-lg-9 {
    padding-left: 9rem;
  }
  .padding-l-lg-10 {
    padding-left: 10rem;
  }
  .padding-l-lg-11 {
    padding-left: 11rem;
  }
  .padding-l-lg-12 {
    padding-left: 12rem;
  }
  .padding-l-lg-13 {
    padding-left: 13rem;
  }
  .padding-l-lg-14 {
    padding-left: 14rem;
  }
  .padding-l-lg-15 {
    padding-left: 15rem;
  }
  .padding-l-lg-16 {
    padding-left: 16rem;
  }
  .padding-l-lg-17 {
    padding-left: 17rem;
  }
  .padding-l-lg-18 {
    padding-left: 18rem;
  }
  .padding-l-lg-19 {
    padding-left: 19rem;
  }
  .padding-l-lg-20 {
    padding-left: 20rem;
  }
}
@media (min-width: 300px) {
  .padding-r-sm-0 {
    padding-right: 0rem;
  }
  .padding-r-sm-1 {
    padding-right: 1rem;
  }
  .padding-r-sm-2 {
    padding-right: 2rem;
  }
  .padding-r-sm-3 {
    padding-right: 3rem;
  }
  .padding-r-sm-4 {
    padding-right: 4rem;
  }
  .padding-r-sm-5 {
    padding-right: 5rem;
  }
  .padding-r-sm-6 {
    padding-right: 6rem;
  }
  .padding-r-sm-7 {
    padding-right: 7rem;
  }
  .padding-r-sm-8 {
    padding-right: 8rem;
  }
  .padding-r-sm-9 {
    padding-right: 9rem;
  }
  .padding-r-sm-10 {
    padding-right: 10rem;
  }
  .padding-r-sm-11 {
    padding-right: 11rem;
  }
  .padding-r-sm-12 {
    padding-right: 12rem;
  }
  .padding-r-sm-13 {
    padding-right: 13rem;
  }
  .padding-r-sm-14 {
    padding-right: 14rem;
  }
  .padding-r-sm-15 {
    padding-right: 15rem;
  }
  .padding-r-sm-16 {
    padding-right: 16rem;
  }
  .padding-r-sm-17 {
    padding-right: 17rem;
  }
  .padding-r-sm-18 {
    padding-right: 18rem;
  }
  .padding-r-sm-19 {
    padding-right: 19rem;
  }
  .padding-r-sm-20 {
    padding-right: 20rem;
  }
}
@media (min-width: 481px) {
  .padding-r-md-0 {
    padding-right: 0rem;
  }
  .padding-r-md-1 {
    padding-right: 1rem;
  }
  .padding-r-md-2 {
    padding-right: 2rem;
  }
  .padding-r-md-3 {
    padding-right: 3rem;
  }
  .padding-r-md-4 {
    padding-right: 4rem;
  }
  .padding-r-md-5 {
    padding-right: 5rem;
  }
  .padding-r-md-6 {
    padding-right: 6rem;
  }
  .padding-r-md-7 {
    padding-right: 7rem;
  }
  .padding-r-md-8 {
    padding-right: 8rem;
  }
  .padding-r-md-9 {
    padding-right: 9rem;
  }
  .padding-r-md-10 {
    padding-right: 10rem;
  }
  .padding-r-md-11 {
    padding-right: 11rem;
  }
  .padding-r-md-12 {
    padding-right: 12rem;
  }
  .padding-r-md-13 {
    padding-right: 13rem;
  }
  .padding-r-md-14 {
    padding-right: 14rem;
  }
  .padding-r-md-15 {
    padding-right: 15rem;
  }
  .padding-r-md-16 {
    padding-right: 16rem;
  }
  .padding-r-md-17 {
    padding-right: 17rem;
  }
  .padding-r-md-18 {
    padding-right: 18rem;
  }
  .padding-r-md-19 {
    padding-right: 19rem;
  }
  .padding-r-md-20 {
    padding-right: 20rem;
  }
}
@media (min-width: 769px) {
  .padding-r-lg-0 {
    padding-right: 0rem;
  }
  .padding-r-lg-1 {
    padding-right: 1rem;
  }
  .padding-r-lg-2 {
    padding-right: 2rem;
  }
  .padding-r-lg-3 {
    padding-right: 3rem;
  }
  .padding-r-lg-4 {
    padding-right: 4rem;
  }
  .padding-r-lg-5 {
    padding-right: 5rem;
  }
  .padding-r-lg-6 {
    padding-right: 6rem;
  }
  .padding-r-lg-7 {
    padding-right: 7rem;
  }
  .padding-r-lg-8 {
    padding-right: 8rem;
  }
  .padding-r-lg-9 {
    padding-right: 9rem;
  }
  .padding-r-lg-10 {
    padding-right: 10rem;
  }
  .padding-r-lg-11 {
    padding-right: 11rem;
  }
  .padding-r-lg-12 {
    padding-right: 12rem;
  }
  .padding-r-lg-13 {
    padding-right: 13rem;
  }
  .padding-r-lg-14 {
    padding-right: 14rem;
  }
  .padding-r-lg-15 {
    padding-right: 15rem;
  }
  .padding-r-lg-16 {
    padding-right: 16rem;
  }
  .padding-r-lg-17 {
    padding-right: 17rem;
  }
  .padding-r-lg-18 {
    padding-right: 18rem;
  }
  .padding-r-lg-19 {
    padding-right: 19rem;
  }
  .padding-r-lg-20 {
    padding-right: 20rem;
  }
}
@media (min-width: 300px) {
  .padding-t-sm-0 {
    padding-top: 0rem;
  }
  .padding-t-sm-1 {
    padding-top: 1rem;
  }
  .padding-t-sm-2 {
    padding-top: 2rem;
  }
  .padding-t-sm-3 {
    padding-top: 3rem;
  }
  .padding-t-sm-4 {
    padding-top: 4rem;
  }
  .padding-t-sm-5 {
    padding-top: 5rem;
  }
  .padding-t-sm-6 {
    padding-top: 6rem;
  }
  .padding-t-sm-7 {
    padding-top: 7rem;
  }
  .padding-t-sm-8 {
    padding-top: 8rem;
  }
  .padding-t-sm-9 {
    padding-top: 9rem;
  }
  .padding-t-sm-10 {
    padding-top: 10rem;
  }
  .padding-t-sm-11 {
    padding-top: 11rem;
  }
  .padding-t-sm-12 {
    padding-top: 12rem;
  }
  .padding-t-sm-13 {
    padding-top: 13rem;
  }
  .padding-t-sm-14 {
    padding-top: 14rem;
  }
  .padding-t-sm-15 {
    padding-top: 15rem;
  }
  .padding-t-sm-16 {
    padding-top: 16rem;
  }
  .padding-t-sm-17 {
    padding-top: 17rem;
  }
  .padding-t-sm-18 {
    padding-top: 18rem;
  }
  .padding-t-sm-19 {
    padding-top: 19rem;
  }
  .padding-t-sm-20 {
    padding-top: 20rem;
  }
}
@media (min-width: 481px) {
  .padding-t-md-0 {
    padding-top: 0rem;
  }
  .padding-t-md-1 {
    padding-top: 1rem;
  }
  .padding-t-md-2 {
    padding-top: 2rem;
  }
  .padding-t-md-3 {
    padding-top: 3rem;
  }
  .padding-t-md-4 {
    padding-top: 4rem;
  }
  .padding-t-md-5 {
    padding-top: 5rem;
  }
  .padding-t-md-6 {
    padding-top: 6rem;
  }
  .padding-t-md-7 {
    padding-top: 7rem;
  }
  .padding-t-md-8 {
    padding-top: 8rem;
  }
  .padding-t-md-9 {
    padding-top: 9rem;
  }
  .padding-t-md-10 {
    padding-top: 10rem;
  }
  .padding-t-md-11 {
    padding-top: 11rem;
  }
  .padding-t-md-12 {
    padding-top: 12rem;
  }
  .padding-t-md-13 {
    padding-top: 13rem;
  }
  .padding-t-md-14 {
    padding-top: 14rem;
  }
  .padding-t-md-15 {
    padding-top: 15rem;
  }
  .padding-t-md-16 {
    padding-top: 16rem;
  }
  .padding-t-md-17 {
    padding-top: 17rem;
  }
  .padding-t-md-18 {
    padding-top: 18rem;
  }
  .padding-t-md-19 {
    padding-top: 19rem;
  }
  .padding-t-md-20 {
    padding-top: 20rem;
  }
}
@media (min-width: 769px) {
  .padding-t-lg-0 {
    padding-top: 0rem;
  }
  .padding-t-lg-1 {
    padding-top: 1rem;
  }
  .padding-t-lg-2 {
    padding-top: 2rem;
  }
  .padding-t-lg-3 {
    padding-top: 3rem;
  }
  .padding-t-lg-4 {
    padding-top: 4rem;
  }
  .padding-t-lg-5 {
    padding-top: 5rem;
  }
  .padding-t-lg-6 {
    padding-top: 6rem;
  }
  .padding-t-lg-7 {
    padding-top: 7rem;
  }
  .padding-t-lg-8 {
    padding-top: 8rem;
  }
  .padding-t-lg-9 {
    padding-top: 9rem;
  }
  .padding-t-lg-10 {
    padding-top: 10rem;
  }
  .padding-t-lg-11 {
    padding-top: 11rem;
  }
  .padding-t-lg-12 {
    padding-top: 12rem;
  }
  .padding-t-lg-13 {
    padding-top: 13rem;
  }
  .padding-t-lg-14 {
    padding-top: 14rem;
  }
  .padding-t-lg-15 {
    padding-top: 15rem;
  }
  .padding-t-lg-16 {
    padding-top: 16rem;
  }
  .padding-t-lg-17 {
    padding-top: 17rem;
  }
  .padding-t-lg-18 {
    padding-top: 18rem;
  }
  .padding-t-lg-19 {
    padding-top: 19rem;
  }
  .padding-t-lg-20 {
    padding-top: 20rem;
  }
}
@media (min-width: 300px) {
  .padding-b-sm-0 {
    padding-bottom: 0rem;
  }
  .padding-b-sm-1 {
    padding-bottom: 1rem;
  }
  .padding-b-sm-2 {
    padding-bottom: 2rem;
  }
  .padding-b-sm-3 {
    padding-bottom: 3rem;
  }
  .padding-b-sm-4 {
    padding-bottom: 4rem;
  }
  .padding-b-sm-5 {
    padding-bottom: 5rem;
  }
  .padding-b-sm-6 {
    padding-bottom: 6rem;
  }
  .padding-b-sm-7 {
    padding-bottom: 7rem;
  }
  .padding-b-sm-8 {
    padding-bottom: 8rem;
  }
  .padding-b-sm-9 {
    padding-bottom: 9rem;
  }
  .padding-b-sm-10 {
    padding-bottom: 10rem;
  }
  .padding-b-sm-11 {
    padding-bottom: 11rem;
  }
  .padding-b-sm-12 {
    padding-bottom: 12rem;
  }
  .padding-b-sm-13 {
    padding-bottom: 13rem;
  }
  .padding-b-sm-14 {
    padding-bottom: 14rem;
  }
  .padding-b-sm-15 {
    padding-bottom: 15rem;
  }
  .padding-b-sm-16 {
    padding-bottom: 16rem;
  }
  .padding-b-sm-17 {
    padding-bottom: 17rem;
  }
  .padding-b-sm-18 {
    padding-bottom: 18rem;
  }
  .padding-b-sm-19 {
    padding-bottom: 19rem;
  }
  .padding-b-sm-20 {
    padding-bottom: 20rem;
  }
}
@media (min-width: 481px) {
  .padding-b-md-0 {
    padding-bottom: 0rem;
  }
  .padding-b-md-1 {
    padding-bottom: 1rem;
  }
  .padding-b-md-2 {
    padding-bottom: 2rem;
  }
  .padding-b-md-3 {
    padding-bottom: 3rem;
  }
  .padding-b-md-4 {
    padding-bottom: 4rem;
  }
  .padding-b-md-5 {
    padding-bottom: 5rem;
  }
  .padding-b-md-6 {
    padding-bottom: 6rem;
  }
  .padding-b-md-7 {
    padding-bottom: 7rem;
  }
  .padding-b-md-8 {
    padding-bottom: 8rem;
  }
  .padding-b-md-9 {
    padding-bottom: 9rem;
  }
  .padding-b-md-10 {
    padding-bottom: 10rem;
  }
  .padding-b-md-11 {
    padding-bottom: 11rem;
  }
  .padding-b-md-12 {
    padding-bottom: 12rem;
  }
  .padding-b-md-13 {
    padding-bottom: 13rem;
  }
  .padding-b-md-14 {
    padding-bottom: 14rem;
  }
  .padding-b-md-15 {
    padding-bottom: 15rem;
  }
  .padding-b-md-16 {
    padding-bottom: 16rem;
  }
  .padding-b-md-17 {
    padding-bottom: 17rem;
  }
  .padding-b-md-18 {
    padding-bottom: 18rem;
  }
  .padding-b-md-19 {
    padding-bottom: 19rem;
  }
  .padding-b-md-20 {
    padding-bottom: 20rem;
  }
}
@media (min-width: 769px) {
  .padding-b-lg-0 {
    padding-bottom: 0rem;
  }
  .padding-b-lg-1 {
    padding-bottom: 1rem;
  }
  .padding-b-lg-2 {
    padding-bottom: 2rem;
  }
  .padding-b-lg-3 {
    padding-bottom: 3rem;
  }
  .padding-b-lg-4 {
    padding-bottom: 4rem;
  }
  .padding-b-lg-5 {
    padding-bottom: 5rem;
  }
  .padding-b-lg-6 {
    padding-bottom: 6rem;
  }
  .padding-b-lg-7 {
    padding-bottom: 7rem;
  }
  .padding-b-lg-8 {
    padding-bottom: 8rem;
  }
  .padding-b-lg-9 {
    padding-bottom: 9rem;
  }
  .padding-b-lg-10 {
    padding-bottom: 10rem;
  }
  .padding-b-lg-11 {
    padding-bottom: 11rem;
  }
  .padding-b-lg-12 {
    padding-bottom: 12rem;
  }
  .padding-b-lg-13 {
    padding-bottom: 13rem;
  }
  .padding-b-lg-14 {
    padding-bottom: 14rem;
  }
  .padding-b-lg-15 {
    padding-bottom: 15rem;
  }
  .padding-b-lg-16 {
    padding-bottom: 16rem;
  }
  .padding-b-lg-17 {
    padding-bottom: 17rem;
  }
  .padding-b-lg-18 {
    padding-bottom: 18rem;
  }
  .padding-b-lg-19 {
    padding-bottom: 19rem;
  }
  .padding-b-lg-20 {
    padding-bottom: 20rem;
  }
}
@media (min-width: 300px) {
  .padding-per-sm-0 {
    padding: 0%;
  }
  .padding-per-sm-1 {
    padding: 1%;
  }
  .padding-per-sm-2 {
    padding: 2%;
  }
  .padding-per-sm-3 {
    padding: 3%;
  }
  .padding-per-sm-4 {
    padding: 4%;
  }
  .padding-per-sm-5 {
    padding: 5%;
  }
  .padding-per-sm-6 {
    padding: 6%;
  }
  .padding-per-sm-7 {
    padding: 7%;
  }
  .padding-per-sm-8 {
    padding: 8%;
  }
  .padding-per-sm-9 {
    padding: 9%;
  }
  .padding-per-sm-10 {
    padding: 10%;
  }
  .padding-per-sm-11 {
    padding: 11%;
  }
  .padding-per-sm-12 {
    padding: 12%;
  }
  .padding-per-sm-13 {
    padding: 13%;
  }
  .padding-per-sm-14 {
    padding: 14%;
  }
  .padding-per-sm-15 {
    padding: 15%;
  }
  .padding-per-sm-16 {
    padding: 16%;
  }
  .padding-per-sm-17 {
    padding: 17%;
  }
  .padding-per-sm-18 {
    padding: 18%;
  }
  .padding-per-sm-19 {
    padding: 19%;
  }
  .padding-per-sm-20 {
    padding: 20%;
  }
}
@media (min-width: 481px) {
  .padding-per-md-0 {
    padding: 0%;
  }
  .padding-per-md-1 {
    padding: 1%;
  }
  .padding-per-md-2 {
    padding: 2%;
  }
  .padding-per-md-3 {
    padding: 3%;
  }
  .padding-per-md-4 {
    padding: 4%;
  }
  .padding-per-md-5 {
    padding: 5%;
  }
  .padding-per-md-6 {
    padding: 6%;
  }
  .padding-per-md-7 {
    padding: 7%;
  }
  .padding-per-md-8 {
    padding: 8%;
  }
  .padding-per-md-9 {
    padding: 9%;
  }
  .padding-per-md-10 {
    padding: 10%;
  }
  .padding-per-md-11 {
    padding: 11%;
  }
  .padding-per-md-12 {
    padding: 12%;
  }
  .padding-per-md-13 {
    padding: 13%;
  }
  .padding-per-md-14 {
    padding: 14%;
  }
  .padding-per-md-15 {
    padding: 15%;
  }
  .padding-per-md-16 {
    padding: 16%;
  }
  .padding-per-md-17 {
    padding: 17%;
  }
  .padding-per-md-18 {
    padding: 18%;
  }
  .padding-per-md-19 {
    padding: 19%;
  }
  .padding-per-md-20 {
    padding: 20%;
  }
}
@media (min-width: 769px) {
  .padding-per-lg-0 {
    padding: 0%;
  }
  .padding-per-lg-1 {
    padding: 1%;
  }
  .padding-per-lg-2 {
    padding: 2%;
  }
  .padding-per-lg-3 {
    padding: 3%;
  }
  .padding-per-lg-4 {
    padding: 4%;
  }
  .padding-per-lg-5 {
    padding: 5%;
  }
  .padding-per-lg-6 {
    padding: 6%;
  }
  .padding-per-lg-7 {
    padding: 7%;
  }
  .padding-per-lg-8 {
    padding: 8%;
  }
  .padding-per-lg-9 {
    padding: 9%;
  }
  .padding-per-lg-10 {
    padding: 10%;
  }
  .padding-per-lg-11 {
    padding: 11%;
  }
  .padding-per-lg-12 {
    padding: 12%;
  }
  .padding-per-lg-13 {
    padding: 13%;
  }
  .padding-per-lg-14 {
    padding: 14%;
  }
  .padding-per-lg-15 {
    padding: 15%;
  }
  .padding-per-lg-16 {
    padding: 16%;
  }
  .padding-per-lg-17 {
    padding: 17%;
  }
  .padding-per-lg-18 {
    padding: 18%;
  }
  .padding-per-lg-19 {
    padding: 19%;
  }
  .padding-per-lg-20 {
    padding: 20%;
  }
}
@media (min-width: 300px) {
  .padding-l-per-sm-0 {
    padding-left: 0%;
  }
  .padding-l-per-sm-1 {
    padding-left: 1%;
  }
  .padding-l-per-sm-2 {
    padding-left: 2%;
  }
  .padding-l-per-sm-3 {
    padding-left: 3%;
  }
  .padding-l-per-sm-4 {
    padding-left: 4%;
  }
  .padding-l-per-sm-5 {
    padding-left: 5%;
  }
  .padding-l-per-sm-6 {
    padding-left: 6%;
  }
  .padding-l-per-sm-7 {
    padding-left: 7%;
  }
  .padding-l-per-sm-8 {
    padding-left: 8%;
  }
  .padding-l-per-sm-9 {
    padding-left: 9%;
  }
  .padding-l-per-sm-10 {
    padding-left: 10%;
  }
  .padding-l-per-sm-11 {
    padding-left: 11%;
  }
  .padding-l-per-sm-12 {
    padding-left: 12%;
  }
  .padding-l-per-sm-13 {
    padding-left: 13%;
  }
  .padding-l-per-sm-14 {
    padding-left: 14%;
  }
  .padding-l-per-sm-15 {
    padding-left: 15%;
  }
  .padding-l-per-sm-16 {
    padding-left: 16%;
  }
  .padding-l-per-sm-17 {
    padding-left: 17%;
  }
  .padding-l-per-sm-18 {
    padding-left: 18%;
  }
  .padding-l-per-sm-19 {
    padding-left: 19%;
  }
  .padding-l-per-sm-20 {
    padding-left: 20%;
  }
}
@media (min-width: 481px) {
  .padding-l-per-md-0 {
    padding-left: 0%;
  }
  .padding-l-per-md-1 {
    padding-left: 1%;
  }
  .padding-l-per-md-2 {
    padding-left: 2%;
  }
  .padding-l-per-md-3 {
    padding-left: 3%;
  }
  .padding-l-per-md-4 {
    padding-left: 4%;
  }
  .padding-l-per-md-5 {
    padding-left: 5%;
  }
  .padding-l-per-md-6 {
    padding-left: 6%;
  }
  .padding-l-per-md-7 {
    padding-left: 7%;
  }
  .padding-l-per-md-8 {
    padding-left: 8%;
  }
  .padding-l-per-md-9 {
    padding-left: 9%;
  }
  .padding-l-per-md-10 {
    padding-left: 10%;
  }
  .padding-l-per-md-11 {
    padding-left: 11%;
  }
  .padding-l-per-md-12 {
    padding-left: 12%;
  }
  .padding-l-per-md-13 {
    padding-left: 13%;
  }
  .padding-l-per-md-14 {
    padding-left: 14%;
  }
  .padding-l-per-md-15 {
    padding-left: 15%;
  }
  .padding-l-per-md-16 {
    padding-left: 16%;
  }
  .padding-l-per-md-17 {
    padding-left: 17%;
  }
  .padding-l-per-md-18 {
    padding-left: 18%;
  }
  .padding-l-per-md-19 {
    padding-left: 19%;
  }
  .padding-l-per-md-20 {
    padding-left: 20%;
  }
}
@media (min-width: 769px) {
  .padding-l-per-lg-0 {
    padding-left: 0%;
  }
  .padding-l-per-lg-1 {
    padding-left: 1%;
  }
  .padding-l-per-lg-2 {
    padding-left: 2%;
  }
  .padding-l-per-lg-3 {
    padding-left: 3%;
  }
  .padding-l-per-lg-4 {
    padding-left: 4%;
  }
  .padding-l-per-lg-5 {
    padding-left: 5%;
  }
  .padding-l-per-lg-6 {
    padding-left: 6%;
  }
  .padding-l-per-lg-7 {
    padding-left: 7%;
  }
  .padding-l-per-lg-8 {
    padding-left: 8%;
  }
  .padding-l-per-lg-9 {
    padding-left: 9%;
  }
  .padding-l-per-lg-10 {
    padding-left: 10%;
  }
  .padding-l-per-lg-11 {
    padding-left: 11%;
  }
  .padding-l-per-lg-12 {
    padding-left: 12%;
  }
  .padding-l-per-lg-13 {
    padding-left: 13%;
  }
  .padding-l-per-lg-14 {
    padding-left: 14%;
  }
  .padding-l-per-lg-15 {
    padding-left: 15%;
  }
  .padding-l-per-lg-16 {
    padding-left: 16%;
  }
  .padding-l-per-lg-17 {
    padding-left: 17%;
  }
  .padding-l-per-lg-18 {
    padding-left: 18%;
  }
  .padding-l-per-lg-19 {
    padding-left: 19%;
  }
  .padding-l-per-lg-20 {
    padding-left: 20%;
  }
}
@media (min-width: 300px) {
  .padding-r-per-sm-0 {
    padding-right: 0%;
  }
  .padding-r-per-sm-1 {
    padding-right: 1%;
  }
  .padding-r-per-sm-2 {
    padding-right: 2%;
  }
  .padding-r-per-sm-3 {
    padding-right: 3%;
  }
  .padding-r-per-sm-4 {
    padding-right: 4%;
  }
  .padding-r-per-sm-5 {
    padding-right: 5%;
  }
  .padding-r-per-sm-6 {
    padding-right: 6%;
  }
  .padding-r-per-sm-7 {
    padding-right: 7%;
  }
  .padding-r-per-sm-8 {
    padding-right: 8%;
  }
  .padding-r-per-sm-9 {
    padding-right: 9%;
  }
  .padding-r-per-sm-10 {
    padding-right: 10%;
  }
  .padding-r-per-sm-11 {
    padding-right: 11%;
  }
  .padding-r-per-sm-12 {
    padding-right: 12%;
  }
  .padding-r-per-sm-13 {
    padding-right: 13%;
  }
  .padding-r-per-sm-14 {
    padding-right: 14%;
  }
  .padding-r-per-sm-15 {
    padding-right: 15%;
  }
  .padding-r-per-sm-16 {
    padding-right: 16%;
  }
  .padding-r-per-sm-17 {
    padding-right: 17%;
  }
  .padding-r-per-sm-18 {
    padding-right: 18%;
  }
  .padding-r-per-sm-19 {
    padding-right: 19%;
  }
  .padding-r-per-sm-20 {
    padding-right: 20%;
  }
}
@media (min-width: 481px) {
  .padding-r-per-md-0 {
    padding-right: 0%;
  }
  .padding-r-per-md-1 {
    padding-right: 1%;
  }
  .padding-r-per-md-2 {
    padding-right: 2%;
  }
  .padding-r-per-md-3 {
    padding-right: 3%;
  }
  .padding-r-per-md-4 {
    padding-right: 4%;
  }
  .padding-r-per-md-5 {
    padding-right: 5%;
  }
  .padding-r-per-md-6 {
    padding-right: 6%;
  }
  .padding-r-per-md-7 {
    padding-right: 7%;
  }
  .padding-r-per-md-8 {
    padding-right: 8%;
  }
  .padding-r-per-md-9 {
    padding-right: 9%;
  }
  .padding-r-per-md-10 {
    padding-right: 10%;
  }
  .padding-r-per-md-11 {
    padding-right: 11%;
  }
  .padding-r-per-md-12 {
    padding-right: 12%;
  }
  .padding-r-per-md-13 {
    padding-right: 13%;
  }
  .padding-r-per-md-14 {
    padding-right: 14%;
  }
  .padding-r-per-md-15 {
    padding-right: 15%;
  }
  .padding-r-per-md-16 {
    padding-right: 16%;
  }
  .padding-r-per-md-17 {
    padding-right: 17%;
  }
  .padding-r-per-md-18 {
    padding-right: 18%;
  }
  .padding-r-per-md-19 {
    padding-right: 19%;
  }
  .padding-r-per-md-20 {
    padding-right: 20%;
  }
}
@media (min-width: 769px) {
  .padding-r-per-lg-0 {
    padding-right: 0%;
  }
  .padding-r-per-lg-1 {
    padding-right: 1%;
  }
  .padding-r-per-lg-2 {
    padding-right: 2%;
  }
  .padding-r-per-lg-3 {
    padding-right: 3%;
  }
  .padding-r-per-lg-4 {
    padding-right: 4%;
  }
  .padding-r-per-lg-5 {
    padding-right: 5%;
  }
  .padding-r-per-lg-6 {
    padding-right: 6%;
  }
  .padding-r-per-lg-7 {
    padding-right: 7%;
  }
  .padding-r-per-lg-8 {
    padding-right: 8%;
  }
  .padding-r-per-lg-9 {
    padding-right: 9%;
  }
  .padding-r-per-lg-10 {
    padding-right: 10%;
  }
  .padding-r-per-lg-11 {
    padding-right: 11%;
  }
  .padding-r-per-lg-12 {
    padding-right: 12%;
  }
  .padding-r-per-lg-13 {
    padding-right: 13%;
  }
  .padding-r-per-lg-14 {
    padding-right: 14%;
  }
  .padding-r-per-lg-15 {
    padding-right: 15%;
  }
  .padding-r-per-lg-16 {
    padding-right: 16%;
  }
  .padding-r-per-lg-17 {
    padding-right: 17%;
  }
  .padding-r-per-lg-18 {
    padding-right: 18%;
  }
  .padding-r-per-lg-19 {
    padding-right: 19%;
  }
  .padding-r-per-lg-20 {
    padding-right: 20%;
  }
}
@media (min-width: 300px) {
  .padding-t-per-sm-0 {
    padding-top: 0%;
  }
  .padding-t-per-sm-1 {
    padding-top: 1%;
  }
  .padding-t-per-sm-2 {
    padding-top: 2%;
  }
  .padding-t-per-sm-3 {
    padding-top: 3%;
  }
  .padding-t-per-sm-4 {
    padding-top: 4%;
  }
  .padding-t-per-sm-5 {
    padding-top: 5%;
  }
  .padding-t-per-sm-6 {
    padding-top: 6%;
  }
  .padding-t-per-sm-7 {
    padding-top: 7%;
  }
  .padding-t-per-sm-8 {
    padding-top: 8%;
  }
  .padding-t-per-sm-9 {
    padding-top: 9%;
  }
  .padding-t-per-sm-10 {
    padding-top: 10%;
  }
  .padding-t-per-sm-11 {
    padding-top: 11%;
  }
  .padding-t-per-sm-12 {
    padding-top: 12%;
  }
  .padding-t-per-sm-13 {
    padding-top: 13%;
  }
  .padding-t-per-sm-14 {
    padding-top: 14%;
  }
  .padding-t-per-sm-15 {
    padding-top: 15%;
  }
  .padding-t-per-sm-16 {
    padding-top: 16%;
  }
  .padding-t-per-sm-17 {
    padding-top: 17%;
  }
  .padding-t-per-sm-18 {
    padding-top: 18%;
  }
  .padding-t-per-sm-19 {
    padding-top: 19%;
  }
  .padding-t-per-sm-20 {
    padding-top: 20%;
  }
}
@media (min-width: 481px) {
  .padding-t-per-md-0 {
    padding-top: 0%;
  }
  .padding-t-per-md-1 {
    padding-top: 1%;
  }
  .padding-t-per-md-2 {
    padding-top: 2%;
  }
  .padding-t-per-md-3 {
    padding-top: 3%;
  }
  .padding-t-per-md-4 {
    padding-top: 4%;
  }
  .padding-t-per-md-5 {
    padding-top: 5%;
  }
  .padding-t-per-md-6 {
    padding-top: 6%;
  }
  .padding-t-per-md-7 {
    padding-top: 7%;
  }
  .padding-t-per-md-8 {
    padding-top: 8%;
  }
  .padding-t-per-md-9 {
    padding-top: 9%;
  }
  .padding-t-per-md-10 {
    padding-top: 10%;
  }
  .padding-t-per-md-11 {
    padding-top: 11%;
  }
  .padding-t-per-md-12 {
    padding-top: 12%;
  }
  .padding-t-per-md-13 {
    padding-top: 13%;
  }
  .padding-t-per-md-14 {
    padding-top: 14%;
  }
  .padding-t-per-md-15 {
    padding-top: 15%;
  }
  .padding-t-per-md-16 {
    padding-top: 16%;
  }
  .padding-t-per-md-17 {
    padding-top: 17%;
  }
  .padding-t-per-md-18 {
    padding-top: 18%;
  }
  .padding-t-per-md-19 {
    padding-top: 19%;
  }
  .padding-t-per-md-20 {
    padding-top: 20%;
  }
}
@media (min-width: 769px) {
  .padding-t-per-lg-0 {
    padding-top: 0%;
  }
  .padding-t-per-lg-1 {
    padding-top: 1%;
  }
  .padding-t-per-lg-2 {
    padding-top: 2%;
  }
  .padding-t-per-lg-3 {
    padding-top: 3%;
  }
  .padding-t-per-lg-4 {
    padding-top: 4%;
  }
  .padding-t-per-lg-5 {
    padding-top: 5%;
  }
  .padding-t-per-lg-6 {
    padding-top: 6%;
  }
  .padding-t-per-lg-7 {
    padding-top: 7%;
  }
  .padding-t-per-lg-8 {
    padding-top: 8%;
  }
  .padding-t-per-lg-9 {
    padding-top: 9%;
  }
  .padding-t-per-lg-10 {
    padding-top: 10%;
  }
  .padding-t-per-lg-11 {
    padding-top: 11%;
  }
  .padding-t-per-lg-12 {
    padding-top: 12%;
  }
  .padding-t-per-lg-13 {
    padding-top: 13%;
  }
  .padding-t-per-lg-14 {
    padding-top: 14%;
  }
  .padding-t-per-lg-15 {
    padding-top: 15%;
  }
  .padding-t-per-lg-16 {
    padding-top: 16%;
  }
  .padding-t-per-lg-17 {
    padding-top: 17%;
  }
  .padding-t-per-lg-18 {
    padding-top: 18%;
  }
  .padding-t-per-lg-19 {
    padding-top: 19%;
  }
  .padding-t-per-lg-20 {
    padding-top: 20%;
  }
}
@media (min-width: 300px) {
  .padding-b-per-sm-0 {
    padding-bottom: 0%;
  }
  .padding-b-per-sm-1 {
    padding-bottom: 1%;
  }
  .padding-b-per-sm-2 {
    padding-bottom: 2%;
  }
  .padding-b-per-sm-3 {
    padding-bottom: 3%;
  }
  .padding-b-per-sm-4 {
    padding-bottom: 4%;
  }
  .padding-b-per-sm-5 {
    padding-bottom: 5%;
  }
  .padding-b-per-sm-6 {
    padding-bottom: 6%;
  }
  .padding-b-per-sm-7 {
    padding-bottom: 7%;
  }
  .padding-b-per-sm-8 {
    padding-bottom: 8%;
  }
  .padding-b-per-sm-9 {
    padding-bottom: 9%;
  }
  .padding-b-per-sm-10 {
    padding-bottom: 10%;
  }
  .padding-b-per-sm-11 {
    padding-bottom: 11%;
  }
  .padding-b-per-sm-12 {
    padding-bottom: 12%;
  }
  .padding-b-per-sm-13 {
    padding-bottom: 13%;
  }
  .padding-b-per-sm-14 {
    padding-bottom: 14%;
  }
  .padding-b-per-sm-15 {
    padding-bottom: 15%;
  }
  .padding-b-per-sm-16 {
    padding-bottom: 16%;
  }
  .padding-b-per-sm-17 {
    padding-bottom: 17%;
  }
  .padding-b-per-sm-18 {
    padding-bottom: 18%;
  }
  .padding-b-per-sm-19 {
    padding-bottom: 19%;
  }
  .padding-b-per-sm-20 {
    padding-bottom: 20%;
  }
}
@media (min-width: 481px) {
  .padding-b-per-md-0 {
    padding-bottom: 0%;
  }
  .padding-b-per-md-1 {
    padding-bottom: 1%;
  }
  .padding-b-per-md-2 {
    padding-bottom: 2%;
  }
  .padding-b-per-md-3 {
    padding-bottom: 3%;
  }
  .padding-b-per-md-4 {
    padding-bottom: 4%;
  }
  .padding-b-per-md-5 {
    padding-bottom: 5%;
  }
  .padding-b-per-md-6 {
    padding-bottom: 6%;
  }
  .padding-b-per-md-7 {
    padding-bottom: 7%;
  }
  .padding-b-per-md-8 {
    padding-bottom: 8%;
  }
  .padding-b-per-md-9 {
    padding-bottom: 9%;
  }
  .padding-b-per-md-10 {
    padding-bottom: 10%;
  }
  .padding-b-per-md-11 {
    padding-bottom: 11%;
  }
  .padding-b-per-md-12 {
    padding-bottom: 12%;
  }
  .padding-b-per-md-13 {
    padding-bottom: 13%;
  }
  .padding-b-per-md-14 {
    padding-bottom: 14%;
  }
  .padding-b-per-md-15 {
    padding-bottom: 15%;
  }
  .padding-b-per-md-16 {
    padding-bottom: 16%;
  }
  .padding-b-per-md-17 {
    padding-bottom: 17%;
  }
  .padding-b-per-md-18 {
    padding-bottom: 18%;
  }
  .padding-b-per-md-19 {
    padding-bottom: 19%;
  }
  .padding-b-per-md-20 {
    padding-bottom: 20%;
  }
}
@media (min-width: 769px) {
  .padding-b-per-lg-0 {
    padding-bottom: 0%;
  }
  .padding-b-per-lg-1 {
    padding-bottom: 1%;
  }
  .padding-b-per-lg-2 {
    padding-bottom: 2%;
  }
  .padding-b-per-lg-3 {
    padding-bottom: 3%;
  }
  .padding-b-per-lg-4 {
    padding-bottom: 4%;
  }
  .padding-b-per-lg-5 {
    padding-bottom: 5%;
  }
  .padding-b-per-lg-6 {
    padding-bottom: 6%;
  }
  .padding-b-per-lg-7 {
    padding-bottom: 7%;
  }
  .padding-b-per-lg-8 {
    padding-bottom: 8%;
  }
  .padding-b-per-lg-9 {
    padding-bottom: 9%;
  }
  .padding-b-per-lg-10 {
    padding-bottom: 10%;
  }
  .padding-b-per-lg-11 {
    padding-bottom: 11%;
  }
  .padding-b-per-lg-12 {
    padding-bottom: 12%;
  }
  .padding-b-per-lg-13 {
    padding-bottom: 13%;
  }
  .padding-b-per-lg-14 {
    padding-bottom: 14%;
  }
  .padding-b-per-lg-15 {
    padding-bottom: 15%;
  }
  .padding-b-per-lg-16 {
    padding-bottom: 16%;
  }
  .padding-b-per-lg-17 {
    padding-bottom: 17%;
  }
  .padding-b-per-lg-18 {
    padding-bottom: 18%;
  }
  .padding-b-per-lg-19 {
    padding-bottom: 19%;
  }
  .padding-b-per-lg-20 {
    padding-bottom: 20%;
  }
}
@media (min-width: 300px) {
  .margin-sm-0 {
    margin: 0rem;
  }
  .margin-sm-1 {
    margin: 1rem;
  }
  .margin-sm-2 {
    margin: 2rem;
  }
  .margin-sm-3 {
    margin: 3rem;
  }
  .margin-sm-4 {
    margin: 4rem;
  }
  .margin-sm-5 {
    margin: 5rem;
  }
  .margin-sm-6 {
    margin: 6rem;
  }
  .margin-sm-7 {
    margin: 7rem;
  }
  .margin-sm-8 {
    margin: 8rem;
  }
  .margin-sm-9 {
    margin: 9rem;
  }
  .margin-sm-10 {
    margin: 10rem;
  }
}
@media (min-width: 481px) {
  .margin-md-0 {
    margin: 0rem;
  }
  .margin-md-1 {
    margin: 1rem;
  }
  .margin-md-2 {
    margin: 2rem;
  }
  .margin-md-3 {
    margin: 3rem;
  }
  .margin-md-4 {
    margin: 4rem;
  }
  .margin-md-5 {
    margin: 5rem;
  }
  .margin-md-6 {
    margin: 6rem;
  }
  .margin-md-7 {
    margin: 7rem;
  }
  .margin-md-8 {
    margin: 8rem;
  }
  .margin-md-9 {
    margin: 9rem;
  }
  .margin-md-10 {
    margin: 10rem;
  }
}
@media (min-width: 769px) {
  .margin-lg-0 {
    margin: 0rem;
  }
  .margin-lg-1 {
    margin: 1rem;
  }
  .margin-lg-2 {
    margin: 2rem;
  }
  .margin-lg-3 {
    margin: 3rem;
  }
  .margin-lg-4 {
    margin: 4rem;
  }
  .margin-lg-5 {
    margin: 5rem;
  }
  .margin-lg-6 {
    margin: 6rem;
  }
  .margin-lg-7 {
    margin: 7rem;
  }
  .margin-lg-8 {
    margin: 8rem;
  }
  .margin-lg-9 {
    margin: 9rem;
  }
  .margin-lg-10 {
    margin: 10rem;
  }
}
@media (min-width: 300px) {
  .margin-l-sm-0 {
    margin-left: 0rem;
  }
  .margin-l-sm-1 {
    margin-left: 1rem;
  }
  .margin-l-sm-2 {
    margin-left: 2rem;
  }
  .margin-l-sm-3 {
    margin-left: 3rem;
  }
  .margin-l-sm-4 {
    margin-left: 4rem;
  }
  .margin-l-sm-5 {
    margin-left: 5rem;
  }
  .margin-l-sm-6 {
    margin-left: 6rem;
  }
  .margin-l-sm-7 {
    margin-left: 7rem;
  }
  .margin-l-sm-8 {
    margin-left: 8rem;
  }
  .margin-l-sm-9 {
    margin-left: 9rem;
  }
  .margin-l-sm-10 {
    margin-left: 10rem;
  }
}
@media (min-width: 481px) {
  .margin-l-md-0 {
    margin-left: 0rem;
  }
  .margin-l-md-1 {
    margin-left: 1rem;
  }
  .margin-l-md-2 {
    margin-left: 2rem;
  }
  .margin-l-md-3 {
    margin-left: 3rem;
  }
  .margin-l-md-4 {
    margin-left: 4rem;
  }
  .margin-l-md-5 {
    margin-left: 5rem;
  }
  .margin-l-md-6 {
    margin-left: 6rem;
  }
  .margin-l-md-7 {
    margin-left: 7rem;
  }
  .margin-l-md-8 {
    margin-left: 8rem;
  }
  .margin-l-md-9 {
    margin-left: 9rem;
  }
  .margin-l-md-10 {
    margin-left: 10rem;
  }
}
@media (min-width: 769px) {
  .margin-l-lg-0 {
    margin-left: 0rem;
  }
  .margin-l-lg-1 {
    margin-left: 1rem;
  }
  .margin-l-lg-2 {
    margin-left: 2rem;
  }
  .margin-l-lg-3 {
    margin-left: 3rem;
  }
  .margin-l-lg-4 {
    margin-left: 4rem;
  }
  .margin-l-lg-5 {
    margin-left: 5rem;
  }
  .margin-l-lg-6 {
    margin-left: 6rem;
  }
  .margin-l-lg-7 {
    margin-left: 7rem;
  }
  .margin-l-lg-8 {
    margin-left: 8rem;
  }
  .margin-l-lg-9 {
    margin-left: 9rem;
  }
  .margin-l-lg-10 {
    margin-left: 10rem;
  }
}
@media (min-width: 300px) {
  .margin-r-sm-0 {
    margin-right: 0rem;
  }
  .margin-r-sm-1 {
    margin-right: 1rem;
  }
  .margin-r-sm-2 {
    margin-right: 2rem;
  }
  .margin-r-sm-3 {
    margin-right: 3rem;
  }
  .margin-r-sm-4 {
    margin-right: 4rem;
  }
  .margin-r-sm-5 {
    margin-right: 5rem;
  }
  .margin-r-sm-6 {
    margin-right: 6rem;
  }
  .margin-r-sm-7 {
    margin-right: 7rem;
  }
  .margin-r-sm-8 {
    margin-right: 8rem;
  }
  .margin-r-sm-9 {
    margin-right: 9rem;
  }
  .margin-r-sm-10 {
    margin-right: 10rem;
  }
}
@media (min-width: 481px) {
  .margin-r-md-0 {
    margin-right: 0rem;
  }
  .margin-r-md-1 {
    margin-right: 1rem;
  }
  .margin-r-md-2 {
    margin-right: 2rem;
  }
  .margin-r-md-3 {
    margin-right: 3rem;
  }
  .margin-r-md-4 {
    margin-right: 4rem;
  }
  .margin-r-md-5 {
    margin-right: 5rem;
  }
  .margin-r-md-6 {
    margin-right: 6rem;
  }
  .margin-r-md-7 {
    margin-right: 7rem;
  }
  .margin-r-md-8 {
    margin-right: 8rem;
  }
  .margin-r-md-9 {
    margin-right: 9rem;
  }
  .margin-r-md-10 {
    margin-right: 10rem;
  }
}
@media (min-width: 769px) {
  .margin-r-lg-0 {
    margin-right: 0rem;
  }
  .margin-r-lg-1 {
    margin-right: 1rem;
  }
  .margin-r-lg-2 {
    margin-right: 2rem;
  }
  .margin-r-lg-3 {
    margin-right: 3rem;
  }
  .margin-r-lg-4 {
    margin-right: 4rem;
  }
  .margin-r-lg-5 {
    margin-right: 5rem;
  }
  .margin-r-lg-6 {
    margin-right: 6rem;
  }
  .margin-r-lg-7 {
    margin-right: 7rem;
  }
  .margin-r-lg-8 {
    margin-right: 8rem;
  }
  .margin-r-lg-9 {
    margin-right: 9rem;
  }
  .margin-r-lg-10 {
    margin-right: 10rem;
  }
}
@media (min-width: 300px) {
  .margin-t-sm-0 {
    margin-top: 0rem;
  }
  .margin-t-sm-1 {
    margin-top: 1rem;
  }
  .margin-t-sm-2 {
    margin-top: 2rem;
  }
  .margin-t-sm-3 {
    margin-top: 3rem;
  }
  .margin-t-sm-4 {
    margin-top: 4rem;
  }
  .margin-t-sm-5 {
    margin-top: 5rem;
  }
  .margin-t-sm-6 {
    margin-top: 6rem;
  }
  .margin-t-sm-7 {
    margin-top: 7rem;
  }
  .margin-t-sm-8 {
    margin-top: 8rem;
  }
  .margin-t-sm-9 {
    margin-top: 9rem;
  }
  .margin-t-sm-10 {
    margin-top: 10rem;
  }
}
@media (min-width: 481px) {
  .margin-t-md-0 {
    margin-top: 0rem;
  }
  .margin-t-md-1 {
    margin-top: 1rem;
  }
  .margin-t-md-2 {
    margin-top: 2rem;
  }
  .margin-t-md-3 {
    margin-top: 3rem;
  }
  .margin-t-md-4 {
    margin-top: 4rem;
  }
  .margin-t-md-5 {
    margin-top: 5rem;
  }
  .margin-t-md-6 {
    margin-top: 6rem;
  }
  .margin-t-md-7 {
    margin-top: 7rem;
  }
  .margin-t-md-8 {
    margin-top: 8rem;
  }
  .margin-t-md-9 {
    margin-top: 9rem;
  }
  .margin-t-md-10 {
    margin-top: 10rem;
  }
}
@media (min-width: 769px) {
  .margin-t-lg-0 {
    margin-top: 0rem;
  }
  .margin-t-lg-1 {
    margin-top: 1rem;
  }
  .margin-t-lg-2 {
    margin-top: 2rem;
  }
  .margin-t-lg-3 {
    margin-top: 3rem;
  }
  .margin-t-lg-4 {
    margin-top: 4rem;
  }
  .margin-t-lg-5 {
    margin-top: 5rem;
  }
  .margin-t-lg-6 {
    margin-top: 6rem;
  }
  .margin-t-lg-7 {
    margin-top: 7rem;
  }
  .margin-t-lg-8 {
    margin-top: 8rem;
  }
  .margin-t-lg-9 {
    margin-top: 9rem;
  }
  .margin-t-lg-10 {
    margin-top: 10rem;
  }
}
@media (min-width: 300px) {
  .margin-b-sm-0 {
    margin-bottom: 0rem;
  }
  .margin-b-sm-1 {
    margin-bottom: 1rem;
  }
  .margin-b-sm-2 {
    margin-bottom: 2rem;
  }
  .margin-b-sm-3 {
    margin-bottom: 3rem;
  }
  .margin-b-sm-4 {
    margin-bottom: 4rem;
  }
  .margin-b-sm-5 {
    margin-bottom: 5rem;
  }
  .margin-b-sm-6 {
    margin-bottom: 6rem;
  }
  .margin-b-sm-7 {
    margin-bottom: 7rem;
  }
  .margin-b-sm-8 {
    margin-bottom: 8rem;
  }
  .margin-b-sm-9 {
    margin-bottom: 9rem;
  }
  .margin-b-sm-10 {
    margin-bottom: 10rem;
  }
}
@media (min-width: 481px) {
  .margin-b-md-0 {
    margin-bottom: 0rem;
  }
  .margin-b-md-1 {
    margin-bottom: 1rem;
  }
  .margin-b-md-2 {
    margin-bottom: 2rem;
  }
  .margin-b-md-3 {
    margin-bottom: 3rem;
  }
  .margin-b-md-4 {
    margin-bottom: 4rem;
  }
  .margin-b-md-5 {
    margin-bottom: 5rem;
  }
  .margin-b-md-6 {
    margin-bottom: 6rem;
  }
  .margin-b-md-7 {
    margin-bottom: 7rem;
  }
  .margin-b-md-8 {
    margin-bottom: 8rem;
  }
  .margin-b-md-9 {
    margin-bottom: 9rem;
  }
  .margin-b-md-10 {
    margin-bottom: 10rem;
  }
}
@media (min-width: 769px) {
  .margin-b-lg-0 {
    margin-bottom: 0rem;
  }
  .margin-b-lg-1 {
    margin-bottom: 1rem;
  }
  .margin-b-lg-2 {
    margin-bottom: 2rem;
  }
  .margin-b-lg-3 {
    margin-bottom: 3rem;
  }
  .margin-b-lg-4 {
    margin-bottom: 4rem;
  }
  .margin-b-lg-5 {
    margin-bottom: 5rem;
  }
  .margin-b-lg-6 {
    margin-bottom: 6rem;
  }
  .margin-b-lg-7 {
    margin-bottom: 7rem;
  }
  .margin-b-lg-8 {
    margin-bottom: 8rem;
  }
  .margin-b-lg-9 {
    margin-bottom: 9rem;
  }
  .margin-b-lg-10 {
    margin-bottom: 10rem;
  }
}
@media (min-width: 300px) {
  .text-align-left-sm {
    text-align: left;
  }
}
@media (min-width: 300px) {
  .text-align-right-sm {
    text-align: right;
  }
}
@media (min-width: 300px) {
  .text-align-center-sm {
    text-align: center;
  }
}
@media (min-width: 481px) {
  .text-align-left-md {
    text-align: left;
  }
}
@media (min-width: 481px) {
  .text-align-right-md {
    text-align: right;
  }
}
@media (min-width: 481px) {
  .text-align-center-md {
    text-align: center;
  }
}
@media (min-width: 769px) {
  .text-align-left-lg {
    text-align: left;
  }
}
@media (min-width: 769px) {
  .text-align-right-lg {
    text-align: right;
  }
}
@media (min-width: 769px) {
  .text-align-center-lg {
    text-align: center;
  }
}
:host {
  --aiba-lib-theme-primary-button-bg-color: yellow;
}

:host {
  display: block;
  --aiba-info-prompt-h2-font-size: 0.625rem;
  --aiba-donut-label-color: black;
  --aiba-donut-label-weight: 400;
  --aiba-donut-label-hover-weight: 400;
}

.skin-progress-bar-header {
  display: flex;
  justify-content: space-between;
  padding: 0 2rem 2rem;
}
@media (max-width: 481px) {
  .skin-progress-bar-header {
    padding: 0 1rem 2rem;
  }
}
.skin-progress-bar-header label {
  font-size: 0.9rem;
  font-weight: 600;
  font-family: roboto, sans-serif;
}

.label-wrapper--p {
  margin: 0;
}

.legend-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.legend-wrapper .color-div {
  margin: 0 !important;
  margin-right: 1rem !important;
}

.skin-progress-bar-wrapper label {
  font-size: 1rem;
  font-weight: 400;
  font-family: roboto, sans-serif;
  text-transform: uppercase;
}
.skin-progress-bar-wrapper .label-wrapper--p {
  font-size: 1.5rem;
  font-family: roboto, sans-serif;
}
.skin-progress-bar-wrapper .compare-label {
  font-size: 1rem;
  margin-left: 1rem;
}

.info-prompt h2 {
  font-size: var(--aiba-info-prompt-h2-font-size) !important;
}

.donut-link-wrapper a {
  color: var(--aiba-donut-label-color);
  font-weight: var(--aiba-donut-label-weight);
}
.donut-link-wrapper a:hover {
  font-weight: var(--aiba-donut-label-hover-weight);
}